import { dateHourToBr, dateToBr } from '../util/date';
import maskCPFandCNPJ from '../util/maskCPFandCNPJ';
import {
  FIELDS_CONSULTA_LOJAS_RELATORIOS_PERSONALIZADO,
  FIELDS_RELATORIO_PERSONALIZADO,
} from './relatorioPersonalizadoMock';

const TABS_PROPOSTA = [
  {
    title: 'Resumo da Proposta',
    hideSearch: true,
    conteudo: [
      {
        type: 'dados_linha',
        remote: {
          method: 'GET',
          service: 'consulta',
          path: 'resumo/dados?',
        },
      },
      {
        type: 'mensagem_alerta',
        remote: {
          method: 'GET',
          service: 'consulta',
          path: 'resumo/alertas?',
        },
      },
    ],
    open: true,
  },
  {
    title: 'Dados da Proposta',
    conteudo: [
      {
        type: 'dados_linha',
        remote: {
          method: 'GET',
          service: 'consulta',
          path:
            'contrato/dadosporgrupo?idGrupo=00000000-0000-0000-0000-000000000000,4c00a6c0-5d44-45cd-9010-b2050e2659fa,5c00c408-0db0-4aec-a66e-eeb88c8c800f,95af0fe0-a137-484e-bcc7-a103bba20c2a,19f5139c-65c3-4766-b3be-2a81336530e8,6c00c729-ae4f-4387-a7a8-ee0730943b15,8644deb6-af7a-43ec-be0e-09d5540d546f,7c00c0a3-f6c2-432b-a6db-3764591f448f&',
        },
      },
    ],
  },
  {
    title: 'Solicitação de Pagamento',
    conteudo: [
      {
        type: 'dados_linha',
        remote: {
          method: 'GET',
          service: 'consulta',
          path: 'contrato/dados?idGrupo=7f5aadd8-65b9-45e4-beff-34b768751877&',
        },
      },
    ],
  },
  {
    title: 'Solicitação de Ponte',
    showOnly: 'dados_linha_abas',
    conteudo: [
      {
        type: 'dados_linha_abas',
        remote: {
          method: 'GET',
          service: 'consulta',
          path: 'contrato/dadosPonte?',
        },
      },
      {
        type: 'criterios',
        remote: {
          method: 'GET',
          service: 'consulta',
          path:
            'contrato/criterios?solicitacaoPonte=true&tipoDoctos=CCB - Cédula de Crédito Bancário - BF,CCB - Cédula de Crédito Bancário - Ford,CCB - Cédula de Crédito Bancário - Harley,Nota Fiscal Eletrônica,DUT do Veículo de Transporte,Proposta de Arrendamento Mercantil - PF - BF,Proposta de Arrendamento Mercantil - PF - Ford,Proposta de Arrendamento Mercantil - PF - Harley,Proposta de Arrendamento Mercantil - PJ - BF,Proposta de Arrendamento Mercantil - PJ - Ford,Proposta de Arrendamento Mercantil - PJ - Harley&',
        },
      },
    ],
  },
  {
    title: 'Dados do Veículo',
    conteudo: [
      {
        type: 'dados_linha',
        remote: {
          method: 'GET',
          service: 'consulta',
          path: 'consulta/veiculo?',
        },
      },
    ],
  },
  {
    title: 'Documentos',
    conteudo: [
      {
        type: 'documentos',
        remote: {
          method: 'GET',
          service: 'consulta',
          path: 'contrato/documentos?',
        },
      },
    ],
  },
  {
    title: 'Análise de Pagamento',
    conteudo: [
      {
        type: 'criterios',
        remote: {
          method: 'GET',
          service: 'mesaveic',
          path: 'analise/documentos?',
        },
      },
    ],
  },
  {
    title: 'Documentos Pendentes',
    conteudo: [
      {
        type: 'criterios',
        remote: {
          method: 'GET',
          service: 'consulta',
          path: 'contrato/criterios?aprova=0&',
        },
      },
    ],
  },
];

const COLUMNS_CONSULTA_PROPOSTA = [
  {
    name: 'farol',
    title: 'Farol',
    type: 'signal',
    rules: [
      { value: 'Alerta_Verde_16x16.png', color: '#c8e0d5', alt: 'Farol' },
      { value: 'Alerta_Amarelo_16x16.png', color: '#e0ce89', alt: 'Farol' },
      { value: 'Alerta_Vermelho_16x16.png', color: '#ebaa9c', alt: 'Farol' },
    ],
    width: '80px',
  },
  {
    name: 'proposta',
    title: 'Número da Proposta',
    key: true,
    showMobile: true,
  },
  { name: 'nome', title: 'Nome do Cliente' },
  { name: 'cpfCnpj', title: 'CPF/CNPJ do Cliente' },
  { name: 'carteira', title: 'Carteira' },
  { name: 'filial', title: 'Filial' },
  { name: 'gefim', title: 'GEFIN' },
  { name: 'dataEnvio', title: 'Data do Envio' },
  { name: 'status', title: 'Status da Proposta' },
];

const LISTA_BANCOS = [
  {
    Id: '001',
    Nome: '001 - Banco do Brasil S.A.',
  },
  {
    Id: '070',
    Nome: '070 - BRB - BANCO DE BRASILIA S.A.',
  },
  {
    Id: '272',
    Nome: '272 - AGK CORRETORA DE CAMBIO S.A.',
  },
  {
    Id: '136',
    Nome: '136 - CONFEDERAÇÃO NACIONAL DAS COOPERATIVAS CENTRAIS UNICRED LTDA. - UNICRED DO BRASI',
  },
  {
    Id: '407',
    Nome: '407 - ÍNDIGO INVESTIMENTOS DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS LTDA.',
  },
  {
    Id: '104',
    Nome: '104 - CAIXA ECONOMICA FEDERAL',
  },
  {
    Id: '077',
    Nome: '077 - Banco Inter S.A.',
  },
  {
    Id: '741',
    Nome: '741 - BANCO RIBEIRAO PRETO S.A.',
  },
  {
    Id: '330',
    Nome: '330 - BANCO BARI DE INVESTIMENTOS E FINANCIAMENTOS S.A.',
  },
  {
    Id: '739',
    Nome: '739 - Banco Cetelem S.A.',
  },
  {
    Id: '743',
    Nome: '743 - Banco Semear S.A.',
  },
  {
    Id: '100',
    Nome: '100 - Planner Corretora de Valores S.A.',
  },
  {
    Id: '096',
    Nome: '096 - Banco B3 S.A.',
  },
  {
    Id: '747',
    Nome: '747 - Banco Rabobank International Brasil S.A.',
  },
  {
    Id: '362',
    Nome: '362 - CIELO S.A.',
  },
  {
    Id: '322',
    Nome: '322 - Cooperativa de Crédito Rural de Abelardo Luz - Sulcredi/Crediluz',
  },
  {
    Id: '748',
    Nome: '748 - BANCO COOPERATIVO SICREDI S.A.',
  },
  {
    Id: '350',
    Nome: '350 - COOPERATIVA DE CRÉDITO RURAL DE PEQUENOS AGRICULTORES E DA REFORMA AGRÁRIA DO CE',
  },
  {
    Id: '752',
    Nome: '752 - Banco BNP Paribas Brasil S.A.',
  },
  {
    Id: '091',
    Nome: '091 - CENTRAL DE COOPERATIVAS DE ECONOMIA E CRÉDITO MÚTUO DO ESTADO DO RIO GRANDE DO S',
  },
  {
    Id: '379',
    Nome: '379 - COOPERFORTE - COOPERATIVA DE ECONOMIA E CRÉDITO MÚTUO DE FUNCIONÁRIOS DE INSTITU',
  },
  {
    Id: '399',
    Nome: '399 - Kirton Bank S.A. - Banco Múltiplo',
  },
  {
    Id: '108',
    Nome: '108 - "PORTOCRED S.A. - CREDITO',
  },
  {
    Id: '378',
    Nome: '378 - BBC LEASING S.A. - ARRENDAMENTO MERCANTIL',
  },
  {
    Id: '756',
    Nome: '756 - BANCO COOPERATIVO DO BRASIL S.A. - BANCOOB',
  },
  {
    Id: '360',
    Nome: '360 - TRINUS CAPITAL DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS S.A.',
  },
  {
    Id: '757',
    Nome: '757 - BANCO KEB HANA DO BRASIL S.A.',
  },
  {
    Id: '102',
    Nome: '102 - "XP INVESTIMENTOS CORRETORA DE CÂMBIO',
  },
  {
    Id: '084',
    Nome: '084 - UNIPRIME NORTE DO PARANÁ - COOPERATIVA DE CRÉDITO LTDA',
  },
  {
    Id: '180',
    Nome: '180 - "CM CAPITAL MARKETS CORRETORA DE CÂMBIO',
  },
  {
    Id: '066',
    Nome: '066 - BANCO MORGAN STANLEY S.A.',
  },
  {
    Id: '015',
    Nome: '015 - "UBS Brasil Corretora de Câmbio',
  },
  {
    Id: '143',
    Nome: '143 - Treviso Corretora de Câmbio S.A.',
  },
  {
    Id: '062',
    Nome: '062 - Hipercard Banco Múltiplo S.A.',
  },
  {
    Id: '074',
    Nome: '074 - Banco J. Safra S.A.',
  },
  {
    Id: '099',
    Nome: '099 - UNIPRIME CENTRAL - CENTRAL INTERESTADUAL DE COOPERATIVAS DE CREDITO LTDA.',
  },
  {
    Id: '387',
    Nome: '387 - Banco Toyota do Brasil S.A.',
  },
  {
    Id: '326',
    Nome: '326 - "PARATI - CREDITO',
  },
  {
    Id: '025',
    Nome: '025 - Banco Alfa S.A.',
  },
  {
    Id: '315',
    Nome: '315 - PI Distribuidora de Títulos e Valores Mobiliários S.A.',
  },
  {
    Id: '075',
    Nome: '075 - Banco ABN Amro S.A.',
  },
  {
    Id: '040',
    Nome: '040 - Banco Cargill S.A.',
  },
  {
    Id: '307',
    Nome: '307 - Terra Investimentos Distribuidora de Títulos e Valores Mobiliários Ltda.',
  },
  {
    Id: '190',
    Nome: '190 - SERVICOOP - COOPERATIVA DE CRÉDITO DOS SERVIDORES PÚBLICOS ESTADUAIS DO RIO GRAN',
  },
  {
    Id: '296',
    Nome: '296 - VISION S.A. CORRETORA DE CAMBIO',
  },
  {
    Id: '063',
    Nome: '063 - Banco Bradescard S.A.',
  },
  {
    Id: '191',
    Nome: '191 - Nova Futura Corretora de Títulos e Valores Mobiliários Ltda.',
  },
  {
    Id: '382',
    Nome: '382 - FIDÚCIA SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E À EMPRESA DE PEQUENO PORTE L',
  },
  {
    Id: '064',
    Nome: '064 - GOLDMAN SACHS DO BRASIL BANCO MULTIPLO S.A.',
  },
  {
    Id: '097',
    Nome: '097 - Credisis - Central de Cooperativas de Crédito Ltda.',
  },
  {
    Id: '016',
    Nome: '016 - COOPERATIVA DE CRÉDITO MÚTUO DOS DESPACHANTES DE TRÂNSITO DE SANTA CATARINA E RI',
  },
  {
    Id: '299',
    Nome: '299 - "SOROCRED   CRÉDITO',
  },
  {
    Id: '012',
    Nome: '012 - Banco Inbursa S.A.',
  },
  {
    Id: '003',
    Nome: '003 - BANCO DA AMAZONIA S.A.',
  },
  {
    Id: '060',
    Nome: '060 - Confidence Corretora de Câmbio S.A.',
  },
  {
    Id: '037',
    Nome: '037 - Banco do Estado do Pará S.A.',
  },
  {
    Id: '411',
    Nome: '411 - "Via Certa Financiadora S.A. - Crédito',
  },
  {
    Id: '359',
    Nome: '359 - "ZEMA CRÉDITO',
  },
  {
    Id: '159',
    Nome: '159 - Casa do Crédito S.A. Sociedade de Crédito ao Microempreendedor',
  },
  {
    Id: '085',
    Nome: '085 - Cooperativa Central de Crédito - Ailos',
  },
  {
    Id: '400',
    Nome: '400 - "COOPERATIVA DE CRÉDITO',
  },
  {
    Id: '410',
    Nome: '410 - PLANNER SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR S.A.',
  },
  {
    Id: '114',
    Nome: '114 - Central Cooperativa de Crédito no Estado do Espírito Santo - CECOOP',
  },
  {
    Id: '036',
    Nome: '036 - Banco Bradesco BBI S.A.',
  },
  {
    Id: '394',
    Nome: '394 - Banco Bradesco Financiamentos S.A.',
  },
  {
    Id: '004',
    Nome: '004 - Banco do Nordeste do Brasil S.A.',
  },
  {
    Id: '320',
    Nome: '320 - China Construction Bank (Brasil) Banco Múltiplo S/A',
  },
  {
    Id: '189',
    Nome: '189 - "HS FINANCEIRA S/A CREDITO',
  },
  {
    Id: '105',
    Nome: '105 - "Lecca Crédito',
  },
  {
    Id: '076',
    Nome: '076 - Banco KDB do Brasil S.A.',
  },
  {
    Id: '082',
    Nome: '082 - BANCO TOPÁZIO S.A.',
  },
  {
    Id: '312',
    Nome: '312 - HSCM - SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E À EMPRESA DE PEQUENO PORTE LT',
  },
  {
    Id: '286',
    Nome: '286 - COOPERATIVA DE CRÉDITO RURAL DE OURO   SULCREDI/OURO',
  },
  {
    Id: '093',
    Nome: '093 - PÓLOCRED   SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E À EMPRESA DE PEQUENO PORT',
  },
  {
    Id: '391',
    Nome: '391 - COOPERATIVA DE CREDITO RURAL DE IBIAM - SULCREDI/IBIAM',
  },
  {
    Id: '273',
    Nome: '273 - Cooperativa de Crédito Rural de São Miguel do Oeste - Sulcredi/São Miguel',
  },
  {
    Id: '368',
    Nome: '368 - Banco CSF S.A.',
  },
  {
    Id: '290',
    Nome: '290 - Pagseguro Internet S.A.',
  },
  {
    Id: '259',
    Nome: '259 - MONEYCORP BANCO DE CÂMBIO S.A.',
  },
  {
    Id: '395',
    Nome: "395 - F.D'GOLD - DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS LTDA.",
  },
  {
    Id: '364',
    Nome: '364 - GERENCIANET S.A.',
  },
  {
    Id: '157',
    Nome: '157 - ICAP do Brasil Corretora de Títulos e Valores Mobiliários Ltda.',
  },
  {
    Id: '183',
    Nome: '183 - SOCRED S.A. - SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E À EMPRESA DE PEQUENO P',
  },
  {
    Id: '014',
    Nome: '014 - STATE STREET BRASIL S.A. ? BANCO COMERCIAL',
  },
  {
    Id: '130',
    Nome: '130 - "CARUANA S.A. - SOCIEDADE DE CRÉDITO',
  },
  {
    Id: '358',
    Nome: '358 - "MIDWAY S.A. - CRÉDITO',
  },
  {
    Id: '127',
    Nome: '127 - Codepe Corretora de Valores e Câmbio S.A.',
  },
  {
    Id: '079',
    Nome: '079 - Banco Original do Agronegócio S.A.',
  },
  {
    Id: '340',
    Nome: '340 - Super Pagamentos e Administração de Meios Eletrônicos S.A.',
  },
  {
    Id: '081',
    Nome: '081 - BancoSeguro S.A.',
  },
  {
    Id: '133',
    Nome: '133 - CONFEDERAÇÃO NACIONAL DAS COOPERATIVAS CENTRAIS DE CRÉDITO E ECONOMIA FAMILIAR E',
  },
  {
    Id: '323',
    Nome: '323 - MERCADOPAGO.COM REPRESENTACOES LTDA.',
  },
  {
    Id: '121',
    Nome: '121 - Banco Agibank S.A.',
  },
  {
    Id: '083',
    Nome: '083 - Banco da China Brasil S.A.',
  },
  {
    Id: '138',
    Nome: '138 - Get Money Corretora de Câmbio S.A.',
  },
  {
    Id: '024',
    Nome: '024 - Banco Bandepe S.A.',
  },
  {
    Id: '384',
    Nome: '384 - GLOBAL FINANÇAS SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E À EMPRESA DE PEQUENO',
  },
  {
    Id: '088',
    Nome: '088 - BANCO RANDON S.A.',
  },
  {
    Id: '319',
    Nome: '319 - OM DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS LTDA',
  },
  {
    Id: '274',
    Nome: '274 - MONEY PLUS SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E A EMPRESA DE PEQUENO PORT',
  },
  {
    Id: '095',
    Nome: '095 - Travelex Banco de Câmbio S.A.',
  },
  {
    Id: '094',
    Nome: '094 - Banco Finaxis S.A.',
  },
  {
    Id: '276',
    Nome: '276 - BANCO SENFF S.A.',
  },
  {
    Id: '092',
    Nome: '092 - "BRK S.A. Crédito',
  },
  {
    Id: '047',
    Nome: '047 - Banco do Estado de Sergipe S.A.',
  },
  {
    Id: '144',
    Nome: '144 - BEXS BANCO DE CÂMBIO S/A',
  },
  {
    Id: '332',
    Nome: '332 - Acesso Soluções de Pagamento S.A.',
  },
  {
    Id: '126',
    Nome: '126 - BR Partners Banco de Investimento S.A.',
  },
  {
    Id: '325',
    Nome: '325 - Órama Distribuidora de Títulos e Valores Mobiliários S.A.',
  },
  {
    Id: '301',
    Nome: '301 - BPP Instituição de Pagamento S.A.',
  },
  {
    Id: '173',
    Nome: '173 - BRL Trust Distribuidora de Títulos e Valores Mobiliários S.A.',
  },
  {
    Id: '331',
    Nome: '331 - Fram Capital Distribuidora de Títulos e Valores Mobiliários S.A.',
  },
  {
    Id: '119',
    Nome: '119 - Banco Western Union do Brasil S.A.',
  },
  {
    Id: '396',
    Nome: '396 - HUB PAGAMENTOS S.A',
  },
  {
    Id: '309',
    Nome: '309 - CAMBIONET CORRETORA DE CÂMBIO LTDA.',
  },
  {
    Id: '254',
    Nome: '254 - PARANÁ BANCO S.A.',
  },
  {
    Id: '268',
    Nome: '268 - BARI COMPANHIA HIPOTECÁRIA',
  },
  {
    Id: '107',
    Nome: '107 - Banco Bocom BBM S.A.',
  },
  {
    Id: '412',
    Nome: '412 - BANCO CAPITAL S.A.',
  },
  {
    Id: '124',
    Nome: '124 - Banco Woori Bank do Brasil S.A.',
  },
  {
    Id: '149',
    Nome: '149 - Facta Financeira S.A. - Crédito Financiamento e Investimento',
  },
  {
    Id: '197',
    Nome: '197 - Stone Pagamentos S.A.',
  },
  {
    Id: '313',
    Nome: '313 - AMAZÔNIA CORRETORA DE CÂMBIO LTDA.',
  },
  {
    Id: '142',
    Nome: '142 - Broker Brasil Corretora de Câmbio Ltda.',
  },
  {
    Id: '389',
    Nome: '389 - Banco Mercantil do Brasil S.A.',
  },
  {
    Id: '184',
    Nome: '184 - Banco Itaú BBA S.A.',
  },
  {
    Id: '634',
    Nome: '634 - BANCO TRIANGULO S.A.',
  },
  {
    Id: '545',
    Nome: '545 - SENSO CORRETORA DE CAMBIO E VALORES MOBILIARIOS S.A',
  },
  {
    Id: '132',
    Nome: '132 - ICBC do Brasil Banco Múltiplo S.A.',
  },
  {
    Id: '298',
    Nome: "298 - Vip's Corretora de Câmbio Ltda.",
  },
  {
    Id: '377',
    Nome: '377 - BMS SOCIEDADE DE CRÉDITO DIRETO S.A.',
  },
  {
    Id: '321',
    Nome: '321 - CREFAZ SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E A EMPRESA DE PEQUENO PORTE LT',
  },
  {
    Id: '260',
    Nome: '260 - Nu Pagamentos S.A.',
  },
  {
    Id: '129',
    Nome: '129 - UBS Brasil Banco de Investimento S.A.',
  },
  {
    Id: '128',
    Nome: '128 - MS Bank S.A. Banco de Câmbio',
  },
  {
    Id: '194',
    Nome: '194 - PARMETAL DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS LTDA',
  },
  {
    Id: '383',
    Nome: '383 - BOLETOBANCÁRIO.COM TECNOLOGIA DE PAGAMENTOS LTDA.',
  },
  {
    Id: '324',
    Nome: '324 - CARTOS SOCIEDADE DE CRÉDITO DIRETO S.A.',
  },
  {
    Id: '310',
    Nome: '310 - VORTX DISTRIBUIDORA DE TITULOS E VALORES MOBILIARIOS LTDA.',
  },
  {
    Id: '380',
    Nome: '380 - PICPAY SERVICOS S.A.',
  },
  {
    Id: '163',
    Nome: '163 - Commerzbank Brasil S.A. - Banco Múltiplo',
  },
  {
    Id: '280',
    Nome: '280 - "WILL FINANCEIRA S.A. CRÉDITO',
  },
  {
    Id: '146',
    Nome: '146 - GUITTA CORRETORA DE CAMBIO LTDA.',
  },
  {
    Id: '343',
    Nome: '343 - FFA SOCIEDADE DE CRÉDITO AO MICROEMPREENDEDOR E À EMPRESA DE PEQUENO PORTE LTDA.',
  },
  {
    Id: '279',
    Nome: '279 - COOPERATIVA DE CREDITO RURAL DE PRIMAVERA DO LESTE',
  },
  {
    Id: '335',
    Nome: '335 - Banco Digio S.A.',
  },
  {
    Id: '349',
    Nome: '349 - "AL5 S.A. CRÉDITO',
  },
  {
    Id: '374',
    Nome: '374 - "REALIZE CRÉDITO',
  },
  {
    Id: '278',
    Nome: '278 - Genial Investimentos Corretora de Valores Mobiliários S.A.',
  },
  {
    Id: '271',
    Nome: '271 - "IB Corretora de Câmbio',
  },
  {
    Id: '021',
    Nome: '021 - BANESTES S.A. BANCO DO ESTADO DO ESPIRITO SANTO',
  },
  {
    Id: '246',
    Nome: '246 - Banco ABC Brasil S.A.',
  },
  {
    Id: '292',
    Nome: '292 - BS2 Distribuidora de Títulos e Valores Mobiliários S.A.',
  },
  {
    Id: '751',
    Nome: '751 - Scotiabank Brasil S.A. Banco Múltiplo',
  },
  {
    Id: '352',
    Nome: '352 - TORO CORRETORA DE TÍTULOS E VALORES MOBILIÁRIOS LTDA',
  },
  {
    Id: '208',
    Nome: '208 - Banco BTG Pactual S.A.',
  },
  {
    Id: '386',
    Nome: '386 - "NU FINANCEIRA S.A. - Sociedade de Crédito',
  },
  {
    Id: '746',
    Nome: '746 - Banco Modal S.A.',
  },
  {
    Id: '241',
    Nome: '241 - BANCO CLASSICO S.A.',
  },
  {
    Id: '398',
    Nome: '398 - IDEAL CORRETORA DE TÍTULOS E VALORES MOBILIÁRIOS S.A.',
  },
  {
    Id: '336',
    Nome: '336 - Banco C6 S.A.',
  },
  {
    Id: '612',
    Nome: '612 - Banco Guanabara S.A.',
  },
  {
    Id: '604',
    Nome: '604 - Banco Industrial do Brasil S.A.',
  },
  {
    Id: '505',
    Nome: '505 - Banco Credit Suisse (Brasil) S.A.',
  },
  {
    Id: '329',
    Nome: '329 - QI Sociedade de Crédito Direto S.A.',
  },
  {
    Id: '196',
    Nome: '196 - FAIR CORRETORA DE CAMBIO S.A.',
  },
  {
    Id: '342',
    Nome: '342 - Creditas Sociedade de Crédito Direto S.A.',
  },
  {
    Id: '300',
    Nome: '300 - Banco de la Nacion Argentina',
  },
  {
    Id: '477',
    Nome: '477 - Citibank N.A.',
  },
  {
    Id: '266',
    Nome: '266 - BANCO CEDULA S.A.',
  },
  {
    Id: '122',
    Nome: '122 - Banco Bradesco BERJ S.A.',
  },
  {
    Id: '376',
    Nome: '376 - BANCO J.P. MORGAN S.A.',
  },
  {
    Id: '348',
    Nome: '348 - Banco XP S.A.',
  },
  {
    Id: '473',
    Nome: '473 - Banco Caixa Geral - Brasil S.A.',
  },
  {
    Id: '745',
    Nome: '745 - Banco Citibank S.A.',
  },
  {
    Id: '120',
    Nome: '120 - BANCO RODOBENS S.A.',
  },
  {
    Id: '265',
    Nome: '265 - Banco Fator S.A.',
  },
  {
    Id: '007',
    Nome: '007 - BANCO NACIONAL DE DESENVOLVIMENTO ECONOMICO E SOCIAL',
  },
  {
    Id: '188',
    Nome: '188 - "ATIVA INVESTIMENTOS S.A. CORRETORA DE TÍTULOS',
  },
  {
    Id: '134',
    Nome: '134 - BGC LIQUIDEZ DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS LTDA',
  },
  {
    Id: '029',
    Nome: '029 - Banco Itaú Consignado S.A.',
  },
  {
    Id: '243',
    Nome: '243 - Banco Máxima S.A.',
  },
  {
    Id: '397',
    Nome: '397 - LISTO SOCIEDADE DE CREDITO DIRETO S.A.',
  },
  {
    Id: '078',
    Nome: '078 - Haitong Banco de Investimento do Brasil S.A.',
  },
  {
    Id: '355',
    Nome: '355 - ÓTIMO SOCIEDADE DE CRÉDITO DIRETO S.A.',
  },
  {
    Id: '367',
    Nome: '367 - VITREO DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS S.A.',
  },
  {
    Id: '373',
    Nome: '373 - UP.P SOCIEDADE DE EMPRÉSTIMO ENTRE PESSOAS S.A.',
  },
  {
    Id: '111',
    Nome: '111 - OLIVEIRA TRUST DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIARIOS S.A.',
  },
  {
    Id: '408',
    Nome: '408 - BÔNUSCRED SOCIEDADE DE CRÉDITO DIRETO S.A.',
  },
  {
    Id: '402',
    Nome: '402 - COBUCCIO SOCIEDADE DE CRÉDITO DIRETO S.A.',
  },
  {
    Id: '404',
    Nome: '404 - SUMUP SOCIEDADE DE CRÉDITO DIRETO S.A.',
  },
  {
    Id: '406',
    Nome: '406 - ACCREDITO - SOCIEDADE DE CRÉDITO DIRETO S.A.',
  },
  {
    Id: '403',
    Nome: '403 - CORA SOCIEDADE DE CRÉDITO DIRETO S.A.',
  },
  {
    Id: '306',
    Nome: '306 - PORTOPAR DISTRIBUIDORA DE TITULOS E VALORES MOBILIARIOS LTDA.',
  },
  {
    Id: '017',
    Nome: '017 - BNY Mellon Banco S.A.',
  },
  {
    Id: '174',
    Nome: '174 - "PEFISA S.A. - CRÉDITO',
  },
  {
    Id: '495',
    Nome: '495 - Banco de La Provincia de Buenos Aires',
  },
  {
    Id: '125',
    Nome: '125 - BANCO GENIAL S.A.',
  },
  {
    Id: '488',
    Nome: '488 - "JPMorgan Chase Bank',
  },
  {
    Id: '065',
    Nome: '065 - Banco AndBank (Brasil) S.A.',
  },
  {
    Id: '492',
    Nome: '492 - ING Bank N.V.',
  },
  {
    Id: '145',
    Nome: '145 - LEVYCAM - CORRETORA DE CAMBIO E VALORES LTDA.',
  },
  {
    Id: '250',
    Nome: '250 - BCV - BANCO DE CRÉDITO E VAREJO S.A.',
  },
  {
    Id: '354',
    Nome: '354 - NECTON INVESTIMENTOS  S.A. CORRETORA DE VALORES MOBILIÁRIOS E COMMODITIES',
  },
  {
    Id: '253',
    Nome: '253 - Bexs Corretora de Câmbio S/A',
  },
  {
    Id: '269',
    Nome: '269 - BANCO HSBC S.A.',
  },
  {
    Id: '213',
    Nome: '213 - Banco Arbi S.A.',
  },
  {
    Id: '139',
    Nome: '139 - Intesa Sanpaolo Brasil S.A. - Banco Múltiplo',
  },
  {
    Id: '018',
    Nome: '018 - Banco Tricury S.A.',
  },
  {
    Id: '422',
    Nome: '422 - Banco Safra S.A.',
  },
  {
    Id: '630',
    Nome: '630 - Banco Smartbank S.A.',
  },
  {
    Id: '224',
    Nome: '224 - Banco Fibra S.A.',
  },
  {
    Id: '393',
    Nome: '393 - Banco Volkswagen S.A.',
  },
  {
    Id: '600',
    Nome: '600 - Banco Luso Brasileiro S.A.',
  },
  {
    Id: '390',
    Nome: '390 - BANCO GM S.A.',
  },
  {
    Id: '623',
    Nome: '623 - Banco Pan S.A.',
  },
  {
    Id: '655',
    Nome: '655 - Banco Votorantim S.A.',
  },
  {
    Id: '479',
    Nome: '479 - Banco ItauBank S.A.',
  },
  {
    Id: '456',
    Nome: '456 - Banco MUFG Brasil S.A.',
  },
  {
    Id: '464',
    Nome: '464 - Banco Sumitomo Mitsui Brasileiro S.A.',
  },
  {
    Id: '341',
    Nome: '341 - ITAÚ UNIBANCO S.A.',
  },
  {
    Id: '237',
    Nome: '237 - Banco Bradesco S.A.',
  },
  {
    Id: '381',
    Nome: '381 - BANCO MERCEDES-BENZ DO BRASIL S.A.',
  },
  {
    Id: '613',
    Nome: '613 - Omni Banco S.A.',
  },
  {
    Id: '652',
    Nome: '652 - Itaú Unibanco Holding S.A.',
  },
  {
    Id: '637',
    Nome: '637 - BANCO SOFISA S.A.',
  },
  {
    Id: '653',
    Nome: '653 - BANCO INDUSVAL S.A.',
  },
  {
    Id: '069',
    Nome: '069 - Banco Crefisa S.A.',
  },
  {
    Id: '370',
    Nome: '370 - Banco Mizuho do Brasil S.A.',
  },
  {
    Id: '249',
    Nome: '249 - Banco Investcred Unibanco S.A.',
  },
  {
    Id: '318',
    Nome: '318 - Banco BMG S.A.',
  },
  {
    Id: '626',
    Nome: '626 - BANCO C6 CONSIGNADO S.A.',
  },
  {
    Id: '270',
    Nome: '270 - Sagitur Corretora de Câmbio Ltda.',
  },
  {
    Id: '366',
    Nome: '366 - BANCO SOCIETE GENERALE BRASIL S.A.',
  },
  {
    Id: '113',
    Nome: '113 - Magliano S.A. Corretora de Cambio e Valores Mobiliarios',
  },
  {
    Id: '131',
    Nome: '131 - TULLETT PREBON BRASIL CORRETORA DE VALORES E CÂMBIO LTDA',
  },
  {
    Id: '011',
    Nome: '011 - CREDIT SUISSE HEDGING-GRIFFO CORRETORA DE VALORES S.A',
  },
  {
    Id: '611',
    Nome: '611 - Banco Paulista S.A.',
  },
  {
    Id: '755',
    Nome: '755 - Bank of America Merrill Lynch Banco Múltiplo S.A.',
  },
  {
    Id: '089',
    Nome: '089 - CREDISAN COOPERATIVA DE CRÉDITO',
  },
  {
    Id: '643',
    Nome: '643 - Banco Pine S.A.',
  },
  {
    Id: '140',
    Nome: '140 - Easynvest - Título Corretora de Valores SA',
  },
  {
    Id: '707',
    Nome: '707 - Banco Daycoval S.A.',
  },
  {
    Id: '288',
    Nome: '288 - CAROL DISTRIBUIDORA DE TITULOS E VALORES MOBILIARIOS LTDA.',
  },
  {
    Id: '363',
    Nome: '363 - SINGULARE CORRETORA DE TÍTULOS E VALORES MOBILIÁRIOS S.A.',
  },
  {
    Id: '101',
    Nome: '101 - RENASCENCA DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIÁRIOS LTDA',
  },
  {
    Id: '487',
    Nome: '487 - DEUTSCHE BANK S.A. - BANCO ALEMAO',
  },
  {
    Id: '233',
    Nome: '233 - Banco Cifra S.A.',
  },
  {
    Id: '177',
    Nome: '177 - Guide Investimentos S.A. Corretora de Valores',
  },
  {
    Id: '365',
    Nome: '365 - SOLIDUS S.A. CORRETORA DE CAMBIO E VALORES MOBILIARIOS',
  },
  {
    Id: '633',
    Nome: '633 - Banco Rendimento S.A.',
  },
  {
    Id: '218',
    Nome: '218 - Banco BS2 S.A.',
  },
  {
    Id: '169',
    Nome: '169 - BANCO OLÉ CONSIGNADO S.A.',
  },
  {
    Id: '293',
    Nome: '293 - Lastro RDV Distribuidora de Títulos e Valores Mobiliários Ltda.',
  },
  {
    Id: '285',
    Nome: '285 - Frente Corretora de Câmbio Ltda.',
  },
  {
    Id: '080',
    Nome: '080 - B&T CORRETORA DE CAMBIO LTDA.',
  },
  {
    Id: '753',
    Nome: '753 - Novo Banco Continental S.A. - Banco Múltiplo',
  },
  {
    Id: '222',
    Nome: '222 - BANCO CRÉDIT AGRICOLE BRASIL S.A.',
  },
  {
    Id: '281',
    Nome: '281 - Cooperativa de Crédito Rural Coopavel',
  },
  {
    Id: '754',
    Nome: '754 - Banco Sistema S.A.',
  },
  {
    Id: '311',
    Nome: '311 - DOURADA CORRETORA DE CÂMBIO LTDA.',
  },
  {
    Id: '098',
    Nome: '098 - Credialiança Cooperativa de Crédito Rural',
  },
  {
    Id: '610',
    Nome: '610 - Banco VR S.A.',
  },
  {
    Id: '712',
    Nome: '712 - Banco Ourinvest S.A.',
  },
  {
    Id: '720',
    Nome: '720 - BANCO RNX S.A.',
  },
  {
    Id: '010',
    Nome: '010 - CREDICOAMO CREDITO RURAL COOPERATIVA',
  },
  {
    Id: '283',
    Nome: '283 - RB INVESTIMENTOS DISTRIBUIDORA DE TITULOS E VALORES MOBILIARIOS LIMITADA',
  },
  {
    Id: '033',
    Nome: '033 - BANCO SANTANDER (BRASIL) S.A.',
  },
  {
    Id: '217',
    Nome: '217 - Banco John Deere S.A.',
  },
  {
    Id: '041',
    Nome: '041 - Banco do Estado do Rio Grande do Sul S.A.',
  },
  {
    Id: '117',
    Nome: '117 - ADVANCED CORRETORA DE CÂMBIO LTDA',
  },
  {
    Id: '654',
    Nome: '654 - BANCO DIGIMAIS S.A.',
  },
  {
    Id: '371',
    Nome: '371 - WARREN CORRETORA DE VALORES MOBILIÁRIOS E CÂMBIO LTDA.',
  },
  {
    Id: '212',
    Nome: '212 - Banco Original S.A.',
  },
  {
    Id: '289',
    Nome: '289 - DECYSEO CORRETORA DE CAMBIO LTDA.',
  },
];

const PROPOSTAS_FILA_LOADING_ACTIONS = [
  '00004625-6381-400B-8AE2-BFCF27682C1C',
  'EEEE9327-76C1-465E-BF28-F8DF5153F38B',
  'E7A12A14-6CD1-4246-A73F-C01B8E885944'
];

const FILTRO_PONTE = [
  {
    name: 'cpfcnpj',
    type: 'input-cpfcnpj',
    placeholder: 'CPF ou CNPJ do favorecido',
    label: 'CPF ou CNPJ do favorecido',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'nomeRazaoSocial',
    type: 'text',
    placeholder: 'Nome ou Razão Social do Favorecido',
    label: 'Nome ou Razão Social do Favorecido',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'dataInicialInclusao',
    type: 'date',
    placeholder: 'Data Inicial Inclusão',
    label: 'Data Inicial Inclusão',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'dataFinalInclusao',
    type: 'date',
    placeholder: 'Data Final Inclusão',
    label: 'Data Final Inclusão',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'statusVigencia',
    type: 'select',
    placeholder: 'Selecione um status',
    label: 'Status da Vigência',
    options: [
      {
        text: 'Ponte vigente',
        value: 'Ponte vigente',
      },
      {
        text: 'Cadastro de ponte não finalizado',
        value: 'Cadastro de ponte não finalizado',
      },
      {
        text: 'Ponte expirada',
        value: 'Ponte expirada',
      },
      {
        text: 'Ponte em processamento',
        value: 'Ponte em processamento',
      },
      {
        text: 'Ponte recusada',
        value: 'Ponte recusada',
      },
    ],
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'carteira',
    type: 'select',
    placeholder: 'Selecione uma carteira',
    label: 'Carteira',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
];

const COLUMNS_CONSULTA_PONTE = [
  {
    name: 'farol',
    title: 'Farol',
    type: 'signal',
    rules: [
      { value: 'verde', color: '#008000', alt: 'Farol' },
      { value: 'amarelo', color: '#ffff00', alt: 'Farol' },
      { value: 'vermelho', color: '#ff0000', alt: 'Farol' },
      { value: 'azul', color: '#00b3ff', alt: 'Farol' },
      { value: 'cinza', color: '#666', alt: 'Farol' },
    ],
    width: '80px',
  },
  {
    name: 'cliente',
    title: 'Cliente',
  },
  {
    name: 'tipo',
    title: 'Tipo',
  },
  {
    name: 'cpfCnpj',
    title: 'CPF ou CNPJ',
  },
  {
    name: 'nomeRazaoSocial',
    title: 'Nome ou razão social',
  },
  {
    name: 'banco',
    title: 'Banco',
  },
  {
    name: 'agencia',
    title: 'Agência',
  },
  {
    name: 'conta',
    title: 'Conta',
  },
  {
    name: 'dataVigencia',
    title: 'Data vigência',
  },
  {
    name: 'status',
    title: 'Status',
  },
];

const COLUMNS_INSERIR_PENDENCIA = [
  {
    name: 'TextoIdCriterio',
    title: 'Tipo de Documento',
  },
  {
    name: 'motivos',
    title: 'Motivos',
  },
  {
    name: 'Observacao',
    title: 'Observação',
  },
];

const FILTRO_RELATORIO_CARGA_ONLINE = [
  {
    type: 'dateRange',
    name: 'recepcao',
    label: 'Data Recepção',
    required: true,
    fields: [
      {
        name: 'dataInicial',
        label: 'Data Recepção Inicial',
        sizeSm: 2,
        sizeMd: 3,
      },
      {
        name: 'dataFinal',
        label: 'Data Recepção Final',
        sizeSm: 2,
        sizeMd: 3,
      },
    ],
  },
  {
    type: 'timeRange',
    name: 'recepcao',
    label: 'Hora',
    periodoMinimo: '90',
    required: true,
    fields: [
      {
        name: 'horaInicial',
        placeholder: 'Hora Inicial',
        label: 'Hora Inicial',
        sizeXs: 12,
        sizeSm: 6,
        sizeMd: 4,
        sizeLg: 3,
      },
      {
        name: 'horaFinal',
        placeholder: 'Hora Final',
        label: 'Hora Final',
        sizeXs: 12,
        sizeSm: 6,
        sizeMd: 4,
        sizeLg: 3,
      },
    ],
  },
  {
    name: 'filial',
    type: 'select',
    placeholder: 'Selecione uma filial',
    label: 'Filial',
    remote: {
      method: 'GET',
      service: 'consulta',
      path: 'relatorio/filiais',
    },
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'sucom',
    type: 'select',
    placeholder: 'Selecione um SUCOM',
    label: 'SUCOM',
    remote: {
      method: 'GET',
      service: 'consulta',
      path: 'relatorio/sucom',
    },
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'tipoRegistro',
    type: 'select',
    placeholder: 'Selecione um tipo',
    label: 'Tipo',
    options: [
      {
        text: 'Balão',
        value: 'Balão',
      },
      {
        text: 'Produtos Agregados',
        value: 'Produtos Agregados',
      },
      {
        text: 'Proposta Cancelada',
        value: 'Proposta Cancelada',
      },
      {
        text: 'Proposta Recusada',
        value: 'Proposta Recusada',
      },
      {
        text: 'Proposta Aprovada',
        value: 'Proposta Aprovada',
      },
      {
        text: 'Proposta Formalizada',
        value: 'Proposta Formalizada',
      },
      {
        text: 'Proposta Excluída',
        value: 'Proposta Excluída',
      },
    ],
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'numeroProposta',
    type: 'number',
    placeholder: 'Número da Proposta',
    label: 'Número da Proposta',
    maxLength: 10,
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
];
//

const FILTRO_RELATORIO_PROCESSOS_PRINCIPAIS = [
  {
    name: 'tipoProcessamento',
    type: 'select-multi',
    placeholder: 'Tipo Processamento',
    label: 'Tipo Processamento',
    options: [
      { value: 'carga-aprovada', label: 'Carga Aprovada do Crédito'},
      { value: 'carga-assinatura', label: 'Carga Assinatura Digital' },
      { value: 'indisponibilidade-imagens', label: 'Indisponibilidade de Imagens' },
    ],
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'datainclusao',
    type: 'dateRange',
    label: 'Data',
    required: true,
    fields: [
      {
        name: 'dataInicial',
        label: 'Data Base Inicial',
        sizeSm: 2,
        sizeMd: 3,
      },
      {
        name: 'dataFinal',
        label: 'Data Base Final',
        sizeSm: 2,
        sizeMd: 3,
      },
    ],
  }
];

const COLUMNS_RELATORIO_CARGA_ONLINE = [
  { name: 'Identificador', title: 'Proposta' },
  { name: 'NomeCliente', title: 'Nome Cliente' },
  { name: 'CPFCNPJCliente', title: 'CPF/CNPJ do cliente' },
  { name: 'DataRecepcao', title: 'Data recepção' },
  { name: 'HoraRecepcao', title: 'Hora recepção' },
  { name: 'NomeGEFIN', title: 'Nome do GEFIN' },
  { name: 'CodigoGEFIN', title: 'Código do GEFIN' },
  { name: 'Filial', title: 'Filial' },
  { name: 'SUCOM', title: 'SUCOM' },
  { name: 'Segmento', title: 'Segmento' },
  { name: 'CodLoja', title: 'Cód. Loja' },
  { name: 'TipoRegistro', title: 'Tipo de Registro' },
];

const COLUMNS_RELATORIO_PROCESSOS_PRINCIPAIS = [
  { name: 'Proposta', title: 'Proposta' },
  { name: 'Contrato', title: 'Contrato' },
  { name: 'Carteira', title: 'Carteira' },
  { name: 'Filial', title: 'Filial' },
  { name: 'Loja', title: 'Loja' },
  { name: 'Posto', title: 'Posto' },
  { name: 'DataCadastro', title: 'Data do Cadastro' },
  { name: 'DataProcessamento', title: 'Data do Processamento' },
  { name: 'TipoProcessamento', title: 'Tipo do Processamento' },
  { name: 'Status', title: "Status"}
];

const COLUMNS_EXCLUSAO_PROPOSTA = [
  {
    name: 'TextoIdCriterio',
    title: 'Tipo de Documento',
  },
  {
    name: 'motivos',
    title: 'Motivos',
  },
  {
    name: 'Observacao',
    title: 'Observação',
  },
];

const FILTRO_CHECKLIST = [
  {
    name: 'nomeChecklist',
    type: 'text',
    placeholder: 'Nome do Checklist',
    label: 'Nome do Checklist',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'tipoFinanciamento',
    type: 'select',
    placeholder: 'Selecione um tipo',
    label: 'Tipo de financiamento',
    options: [
      {
        text: 'Leasing',
        value: 'leasing',
      },
      {
        text: 'CDC',
        value: 'cdc',
      },
    ],
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'veiculo',
    type: 'select',
    placeholder: 'Selecione um tipo',
    label: 'Veículo',
    options: [
      {
        text: 'Novo',
        value: 0,
      },
      {
        text: 'Usado',
        value: 1,
      },
    ],
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'carteira',
    type: 'select',
    placeholder: 'Selecione uma carteira',
    label: 'Carteira',
    remote: {
      method: 'GET',
      service: 'consulta',
      path: '/consulta/carteiras',
    },
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'titularidade',
    type: 'select',
    placeholder: 'Selecione um tipo',
    label: 'Titularidade',
    options: [
      {
        text: 'Pessoa física',
        value: 'PF',
      },
      {
        text: 'Pessoa jurídica',
        value: 'PJ',
      },
    ],
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'diversosBens',
    type: 'select',
    placeholder: 'Selecione um item',
    label: 'Possui Diversos Bens?',
    options: [
      {
        text: 'Sim',
        value: 'Sim',
      },
      {
        text: 'Não',
        value: 'Não',
      },
    ],
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'balcao',
    type: 'select',
    placeholder: 'Selecione um item',
    label: 'Proposta Balcão?',
    options: [
      {
        text: 'Sim',
        value: 'Sim',
      },
      {
        text: 'Não',
        value: 'Não',
      },
    ],
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'combo',
    type: 'select',
    placeholder: 'Selecione um item',
    label: 'Possui Combo de Vendas?',
    options: [
      {
        text: 'Sim',
        value: 'Sim',
      },
      {
        text: 'Não',
        value: 'Não',
      },
    ],
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
];

const COLUMNS_CHECKLIST = [
  {
    name: 'checklist',
    title: 'Checklist',
  },
  {
    name: 'documentos',
    title: 'Qtde. Documentos',
  },
  {
    name: 'status',
    title: 'Status',
    type: 'switch',
  },
];

const COLUMNS_LIBERACAO_PROPOSTA = [
  {
    name: 'documento',
    title: 'Documento',
  },
  {
    name: 'resposta',
    title: 'Resposta',
  },
  {
    name: 'motivos',
    title: 'Motivos',
  },
];

const FILTRO_ATUALIZAR_EMAILS = [
  {
    name: 'login',
    type: 'text',
    placeholder: 'Login',
    label: 'Login',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'cpfCnpj',
    type: 'input-cpfcnpj',
    placeholder: 'CPF',
    label: 'CPF',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
];

const COLUMNS_ATUALIZAR_EMAILS = [
  {
    name: 'Userid',
    title: 'Login',
  },
  {
    name: 'Nome',
    title: 'Nome',
  },
  {
    name: 'maskedCpfCnpj',
    title: 'CPF',
  },
  {
    name: 'email',
    title: 'E-mail',
  },
];

const FILTRO_CHECKLIST_AVALIACAO_COMFORMIDADE = [
  {
    name: 'cnpj',
    type: 'input-cpfcnpj',
    placeholder: 'CNPJ',
    label: 'CNPJ',
    required: true,
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'razaoSocial',
    type: 'text',
    placeholder: 'Razão Social',
    label: 'Razão Social',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'status',
    type: 'select',
    placeholder: 'Selecione um item',
    label: 'Status',
    remote: {
      method: 'GET',
      service: 'mesaveic',
      path: '/avaliacaoConformidade/status',
    },
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    type: 'dateRange',
    name: 'indicação',
    label: 'Data Indicação',
    required: true,
    fields: [
      {
        name: 'dataInicial',
        type: 'date',
        placeholder: '',
        label: 'Data-Início',
        sizeXs: 12,
        sizeSm: 6,
        sizeMd: 4,
        sizeLg: 3,
      },
      {
        name: 'dataFinal',
        type: 'date',
        placeholder: '',
        label: 'Data-Fim',
        sizeXs: 12,
        sizeSm: 6,
        sizeMd: 4,
        sizeLg: 3,
      },
    ],
  },
];

const COLUMNS_CHECKLIST_AVALIACAO_CONFORMIDADE = [
  {
    name: 'farol',
    title: 'Farol',
    type: 'signal',
    rules: [
      {
        value: 'Alerta_Verde_16x16.png',
        color: '#c8e0d5',
        alt: 'Dentro do prazo estabelecido',
      },
      {
        value: 'Alerta_Amarelo_16x16.png',
        color: '#e0ce89',
        alt: 'Prazo prestes a vencer',
      },
      {
        value: 'Alerta_Vermelho_16x16.png',
        color: '#ebaa9c',
        alt: 'Fora do Prazo',
      },
    ],
    width: '80px',
  },
  {
    name: 'dataIndicacao',
    title: 'Data da Indicação',
  },
  {
    name: 'razaoSocial',
    title: 'Razão Social',
  },
  {
    name: 'cnpj',
    title: 'CNPJ',
  },
  {
    name: 'segmento',
    title: 'Segmento',
  },
  {
    name: 'statusAvaliacao',
    title: 'Status da Avaliação',
  },
];

const FILTRO_CONSULTA_HIERARQUIA = [
  {
    name: 'codcliente',
    type: 'text',
    placeholder: 'Código do Promotor',
    label: 'Código do Promotor',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'userid',
    type: 'text',
    placeholder: 'Login',
    label: 'Login',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
];

const COLUMNS_CONSULTA_HIERARQUIA = [
  {
    key: true,
    name: 'Usuario',
    title: 'Usuário',
  },
  {
    name: 'Codigo',
    title: 'Código',
  },
  {
    name: 'Nome',
    title: 'Nome',
  },
  {
    name: 'Telefone',
    title: 'Telefone',
  },
  {
    name: 'Email',
    title: 'E-mail',
  },
];

const COLUMNS_CONSULTA_HIERARQUIA_FILIAIS = [
  {
    name: 'CodFilial',
    title: 'Cod. Filial',
  },
  {
    name: 'Nome',
    title: 'Filial',
  },
  {
    name: 'GecomName',
    title: 'GECOM',
  },
  {
    name: 'SucomName',
    title: 'SUCOM',
  },
  {
    type: 'custom',
    title: 'Ações',
  },
];

const FILTRO_CONSULTA_PERFIL = [
  {
    name: 'perfil',
    type: 'text',
    placeholder: 'Perfil',
    label: 'Perfil',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'empresa',
    type: 'text',
    placeholder: 'Empresa',
    label: 'Empresa',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
];

const COLUMNS_CONSULTA_PERFIL = [
  {
    name: 'Descricao',
    title: 'Perfil',
  },
  {
    name: 'Nome',
    title: 'Empresa',
  },
];

const COLUMNS_CONSULTA_USUARIOS = [
  {
    name: 'Nome',
    title: 'Nome Completo',
  },
  {
    name: 'IdCodCliente',
    title: 'Código',
  },
  {
    name: 'Userid',
    title: 'Funcional / CNPJ',
  },
  {
    name: 'DescricaoPerfil',
    title: 'Perfil',
  },
  {
    name: 'DataCriacao',
    title: 'Data do Cadastro',
  },
  {
    name: 'DataInicioBloqueio',
    title: 'Data Início Bloqueio',
  },
  {
    name: 'DataFinalBloqueio',
    title: 'Data Final Bloqueio',
  },
  /* {
      name: 'Userid',
      title: 'Usuário Substituto',
   }, */
  {
    name: 'Status',
    title: 'Status',
  },
];

const FILTRO_CONSULTA_USUARIOS = [
  {
    name: 'Nome',
    type: 'text',
    placeholder: 'Nome / Razão Social',
    label: 'Nome / Razão Social',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'funcional',
    type: 'text',
    placeholder: 'Funcional / CNPJ',
    label: 'Funcional / CNPJ',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'Perfil',
    type: 'select',
    remote: {
      method: 'GET',
      service: 'mesaveic',
      path: '/gestaoAcessos/listarPerfis?formatado=true',
    },
    placeholder: 'Perfil',
    label: 'Perfil',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },

  {
    name: 'Status',
    type: 'select',
    placeholder: 'Selecione um Status',
    label: 'Status do usuário',
    options: [
      {
        text: 'Ativo',
        value: 0,
      },
      {
        text: 'Desativado',
        value: 255,
      },
      {
        text: 'Bloqueado',
        value: 254,
      },
    ],
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'IdCodCliente',
    type: 'text',
    placeholder: 'Código',
    label: 'Código',
    maxLength: 3,
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    type: 'dateRange',
    name: 'bloqueio',
    label: 'Data Bloqueio',
    required: true,
    fields: [
      {
        name: 'DataInicialBloqueio',
        type: 'date',
        placeholder: '',
        label: 'Data Início Bloqueio',
        sizeXs: 12,
        sizeSm: 6,
        sizeMd: 4,
        sizeLg: 3,
      },
      {
        name: 'DataFinalBloqueio',
        type: 'date',
        placeholder: '',
        label: 'Data Final Bloqueio',
        sizeXs: 12,
        sizeSm: 6,
        sizeMd: 4,
        sizeLg: 3,
      },
    ],
  },
];
const FIELDS_CADASTRO_USUARIO = [
  {
    name: 'Nome',
    type: 'text',
    required: true,
    placeholder: 'Nome / Razão Social',
    label: 'Nome / Razão Social',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'email',
    type: 'text',
    required: true,
    placeholder: 'Email',
    label: 'Email',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'CPF',
    type: 'input-cpfcnpj',
    required: true,
    placeholder: 'CPF ou CNPJ do Cliente',
    label: 'CPF ou CNPJ do Cliente',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'Telefone',
    type: 'text',
    placeholder: 'Telefone',
    label: 'Telefone',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'perfil',
    type: 'select-multi',
    required: true,
    placeholder: 'Perfil',
    label: 'Perfil',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'Userid',
    type: 'text',
    required: true,
    placeholder: 'Funcional / CNPJ (Login de acesso)',
    label: 'Funcional / CNPJ (Login de acesso)',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
];

const FILTRO_REANALISE = [
  {
    name: 'proposta',
    type: 'number',
    placeholder: 'Número da Proposta',
    label: 'Número da Proposta',
    maxLength: 10,
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'cpfCnpjCliente',
    type: 'input-cpfcnpj',
    placeholder: 'CPF ou CNPJ do Cliente',
    label: 'CPF ou CNPJ do Cliente',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'cpfCnpjLoja',
    type: 'input-cpfcnpj',
    placeholder: 'CPF ou CNPJ da loja',
    label: 'CPF ou CNPJ da Loja',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'gefin',
    type: 'text',
    placeholder: 'Código do GEFIN',
    label: 'Código do GEFIN',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'sucom',
    type: 'select-autocomplete',
    placeholder: 'SUCOM',
    label: 'SUCOM',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
    remote: {
      method: 'GET',
      service: 'consulta',
      path: 'consulta/sucoms',
    },
  },
  {
    name: 'carteira',
    type: 'text',
    placeholder: 'Carteira',
    label: 'Carteira',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'segmento',
    type: 'select',
    placeholder: 'Selecione um segmento',
    label: 'Segmento',
    options: [
      {
        text: 'Leve',
        value: 'Leve',
      },
      {
        text: 'Big Dealer',
        value: 'Big Dealer',
      },
      {
        text: 'Jeep',
        value: 'Jeep',
      },
      {
        text: 'Ford',
        value: 'Ford',
      },
      {
        text: 'Motos',
        value: 'Motos',
      },
      {
        text: 'Transportes',
        value: 'Transportes',
      },
    ],
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    type: 'dateRange',
    name: 'indicação',
    label: 'Data Indicação',
    required: true,
    fields: [
      {
        name: 'dataInicialIndicacao',
        type: 'date',
        placeholder: '',
        label: 'Data-Início',
        sizeXs: 12,
        sizeSm: 6,
        sizeMd: 4,
        sizeLg: 3,
      },
      {
        name: 'dataFinalIndicacao',
        type: 'date',
        placeholder: '',
        label: 'Data-Fim',
        sizeXs: 12,
        sizeSm: 6,
        sizeMd: 4,
        sizeLg: 3,
      },
    ],
  },
];

const COLUMNS_REANALISE = [
  {
    name: 'farol',
    title: 'Farol',
    type: 'signal',
    rules: [
      { value: 'Alerta_Verde_16x16.png', color: '#c8e0d5', alt: 'Farol' },
      { value: 'Alerta_Amarelo_16x16.png', color: '#e0ce89', alt: 'Farol' },
      { value: 'Alerta_Vermelho_16x16.png', color: '#ebaa9c', alt: 'Farol' },
    ],
    width: '80px',
  },
  {
    key: true,
    name: 'proposta',
    title: 'Número da Proposta',
  },
  { name: 'cpfCnpjCliente', title: 'CPF/CNPJ do Cliente' },
  { name: 'nomeCliente', title: 'Nome Cliente' },
  { name: 'carteira', title: 'Carteira' },
  { name: 'filial', title: 'Filial' },
  { name: 'dataEnvio', title: 'Data e Hora do Envio' },
  { name: 'status', title: 'Status da Proposta' },
  { name: 'motivo', title: 'Motivo' },
];

const COLUMNS_REANALISE_EXCLUSAO = [
  {
    title: 'Data e Hora',
    name: 'DataExclusao',
  },
  {
    title: 'Tipo de Documento',
    name: 'Apelido',
  },
  {
    title: 'Motivo',
    name: 'Motivos',
  },
];

const COLUMNS_FORMULARIOS_CONFORMIDADE = [
  {
    title: 'Formulário',
    name: 'Formulario',
    key: true,
  },
  {
    title: 'Qtde. Perguntas',
    name: 'QtdePerguntas',
  },
  {
    title: 'Vigência',
    name: 'Datavigencia',
  },
];

const COLUMNS_CHECKLIST_RELATORIO_CONFORMIDADE = [
  {
    title: 'CNPJ',
    name: 'CNPJ',
    width: '150px',
  },
  {
    title: 'Razão Social',
    name: 'RazaoSocial',
    width: '150px',
  },
  /* {
      title: 'Nome Fantasia',
      name: 'nomeFantasia',
   }, */
  {
    title: 'Filial',
    name: 'Filial',
  },
  {
    title: 'Segmento',
    name: 'Segmento',
  },
  {
    title: 'Código Loja',
    name: 'CodigoLoja',
  },
  {
    title: 'Avaliador',
    name: 'Avaliador',
  },
  {
    title: 'Indicação',
    name: 'Indicacao',
  },
  /* {
      title: 'Visita',
      name: 'visita',
   }, */
  {
    title: 'Preenchimento da Avaliação',
    name: 'Visita',
  },
  {
    title: 'Status',
    name: 'Status',
  },
  /* {
      title: 'Atualização Status',
      name: 'atualizacaoStatus',
   }, */
];

const CICLO_RELATORIO_CONFORMIDADE = [
  {
    text: '1º Trimestre',
    value: '1',
  },
  {
    text: '2º Trimestre',
    value: '2',
  },
  {
    text: '3º Trimestre',
    value: '3',
  },
  {
    text: '4º Trimestre',
    value: '4',
  },
];

const STATUS_RELATORIO_CONFORMIDADE = [
  {
    text: 'Indicado',
    value: 'a4db4c4e-6bdd-41be-8759-6488624c717e',
  },
  {
    text: 'Não Conforme',
    value: 'bfac089b-7908-449c-a000-303da2204e67',
  },
  {
    text: 'Conforme',
    value: 'bfac13f1-efd4-49a6-be0c-e87da854fea1',
  },
  {
    text: 'Regularizado',
    value: 'c6904b7f-ea86-4b88-b3ef-0bc4270d07db',
  },
  {
    text: 'Desativado',
    value: '9a00bdc7-fb09-4376-9c0c-2e64d7f643dd',
  },
  /* {
      text: 'Cancelado',
      value: 'Cancelado',
   }, */
  {
    text: 'Finalizado',
    value: 'bfac5563-ddc4-47e7-8596-cd4aea390a40',
  },
];

const COLUMNS_RELATORIO_USUARIOS_BLOQUEIO = [
  {
    name: 'NomedoUsuario',
    title: 'Nome do Usuário',
  },
  {
    name: 'CodigoPromotor',
    title: 'Codigo',
  },
  {
    name: 'LogindoUsuarioFuncional',
    title: 'Funcional/Login',
  },
  {
    name: 'CPFdousuario',
    title: 'CPF do Usuário',
  },
  {
    name: 'DataIniciodoBloqueio',
    title: 'Data Início Bloqueio',
  },
  {
    name: 'DataFinaldoBloqueio',
    title: 'Data Final Bloqueio',
  },
  {
    name: 'NomedoSubstituto',
    title: 'Nome do Substituto',
  },
  {
    name: 'CodigoSubstituto',
    title: 'Código Substituto',
  },
  {
    name: 'FuncionaldoSubstituto',
    title: 'Funcional do substituto',
  },
  {
    name: 'CPFdoSubstituto',
    title: 'CPF do Substituto ',
  },
];

const COLUMNS_RELATORIO_USUARIOS_GESTAO = [
  {
    name: 'Status',
    title: 'Status',
  },
  {
    name: 'Nome',
    title: 'Nome do usuário',
  },
  {
    name: 'CodigodeTresCaracteres',
    title: 'Código',
  },
  {
    name: 'LogindoUsuarioFuncional',
    title: 'Login do usuário/Funcional',
  },
  {
    name: 'CPFCNPJ',
    title: 'CPF/CNPJ',
  },
  {
    name: 'Email',
    title: 'Email',
  },
  {
    name: 'DatadoUltimoAcesso',
    title: 'Data do último acesso',
  },
  {
    name: 'Funcionalidade',
    title: 'Funcionalidade',
  },
];

const COLUMNS_IMPRESSAO_DOCS = [
  {
    title: '',
    type: 'checkbox',
    name: 'checked',
  },
  {
    title: 'Tipo Documental',
    name: 'Tipo',
  },
  {
    key: true,
    title: 'Documento',
    name: 'Documento',
  },
  {
    title: 'Data Recebimento do Documento',
    name: 'DataCaptura',
    dataFormat: (cell) => dateHourToBr(cell),
  },
];

const COLUMNS_HISTORICO_RELATORIO = [
  {
    name: 'tipo',
    title: 'Tipo de Relatório',
  },
  {
    name: 'data',
    title: 'Data',
    dataFormat: (cell) => dateToBr(cell)
  },
  {
    name: 'hora',
    title: 'Hora',
  },
  {
    name: 'download',
    title: 'Download',
    type: 'custom',
  },
];
const FILTRO_MONITOR_COMERCIAL_PRE = [
  {
    name: 'sucom',
    type: 'select',
    placeholder: 'Selecione um SUCOM',
    label: 'SUCOM',
    remote: {
      method: 'GET',
      service: 'consulta',
      path: 'relatorio/sucom',
    },
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'gecom',
    type: 'select',
    placeholder: 'Selecione um GECOM',
    label: 'GECOM',
    options: [],
    //disabled: true,
    /*remote: {
      method: 'GET',
      service: 'consulta',
      path: 'relatorio/sucom',
    },*/
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'gefin',
    type: 'select',
    placeholder: 'Selecione um GEFIN',
    label: 'GEFIN',
    //disabled: true,
    /*remote: {
      method: 'GET',
      service: 'consulta',
      path: 'relatorio/sucom',
    },*/
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    type: 'dateRange',
    name: 'periodo',
    label: 'Periodo',
    fields: [
      {
        name: 'periodoInicial',
        type: 'date',
        placeholder: '',
        label: 'Período Inicial',
        sizeXs: 12,
        sizeSm: 6,
        sizeMd: 4,
        sizeLg: 3,
      },
      {
        name: 'periodoFinal',
        type: 'date',
        placeholder: '',
        label: 'Período Final',
        sizeXs: 12,
        sizeSm: 6,
        sizeMd: 4,
        sizeLg: 3,
      },
    ],
  },
];
const COLUMNS_MONITOR_COMERCIAL_PRE = [
  {
    name: 'nomeFilial',
    type: 'custom',
    style: { backgroundColor: '#767171', textAlign: 'center' },
  },
  {
    name: 'aprovada',
    title: 'Aprovada',
    type: 'custom',
    style: { backgroundColor: '#1fa444', textAlign: 'center' },
  },
  {
    name: 'analise',
    title: 'Em Análise',
    type: 'custom',
    style: { backgroundColor: '#499be3', textAlign: 'center' },
  },
  {
    name: 'pendente',
    title: 'Pendente',
    type: 'custom',
    style: { backgroundColor: '#f79a02', textAlign: 'center' },
  },
  {
    name: 'liberadas',
    title: 'Liberadas',
    type: 'custom',
    style: { backgroundColor: '#69a12b', textAlign: 'center' },
  },
  {
    name: 'excluidas',
    title: 'Excluidas',
    type: 'custom',
    style: { backgroundColor: '#c00000', textAlign: 'center' },
  },
  {
    name: 'total',
    title: 'Total',
    type: 'custom',
    style: { backgroundColor: '#767171', textAlign: 'center' },
  },
];

const COLUMNS_PRE_ANALISE_RISCO = [
  {
    name: 'Proposta',
    title: 'Número da Proposta',
  },
  {
    name: 'CpfCnpjCliente',
    title: 'CPF/CNPJ do Cliente',
  },
  {
    name: 'NomeCliente',
    title: 'Nome do Cliente',
  },
  {
    name: 'Carteira',
    title: 'Carteira',
  },
  {
    name: 'Filial',
    title: 'Filial',
  },
  {
    name: 'DataEnvio',
    title: 'Data e Hora de Envio',
  },
  {
    name: 'Status',
    title: 'Status da Proposta',
  },
];

const FILTRO_PRE_ANALISE_RISCO = [
  {
    name: 'proposta',
    type: 'number',
    placeholder: 'Número da Proposta',
    label: 'Número da Proposta',
    maxLength: 10,
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'cpfCnpjCliente',
    type: 'input-cpfcnpj',
    placeholder: 'CPF ou CNPJ do Cliente',
    label: 'CPF ou CNPJ do Cliente',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    type: 'dateRange',
    name: 'dataEnvio',
    label: 'Data Envio',
    required: true,
    fields: [
      {
        name: 'dataInicio',
        type: 'date',
        placeholder: '',
        label: 'Data Início',
        sizeXs: 12,
        sizeSm: 6,
        sizeMd: 4,
        sizeLg: 3,
      },
      {
        name: 'dataFim',
        type: 'date',
        placeholder: '',
        label: 'Data Fim',
        sizeXs: 12,
        sizeSm: 6,
        sizeMd: 4,
        sizeLg: 3,
      },
    ],
  },
  {
    type: 'timeRange',
    name: 'horaEnvio',
    label: 'Data Envio',
    required: true,
    fields: [
      {
        name: 'horaInicial',
        placeholder: 'Hora Inicial',
        label: 'Hora Inicial',
        sizeXs: 12,
        sizeSm: 6,
        sizeMd: 4,
        sizeLg: 3,
      },
      {
        name: 'horaFinal',
        placeholder: 'Hora Final',
        label: 'Hora Final',
        sizeXs: 12,
        sizeSm: 6,
        sizeMd: 4,
        sizeLg: 3,
      },
    ],
  },
];

const COLUMNS_MONITOR_ANALITICO = [
  {
    name: 'codigoGefin',
    title: 'Cód. GEFIN',
  },
  {
    name: 'nomeGefin',
    title: 'Nome do GEFIN',
  },
  {
    name: 'filial',
    title: 'Filial',
  },

  {
    name: 'codigoLoja',
    title: 'Cód. Loja',
  },
  {
    name: 'nomeLoja',
    title: 'Nome da Loja',
  },
  {
    name: 'numeroProposta',
    title: 'Número da Proposta',
  },
  {
    name: 'nomeCliente',
    title: 'Nome do Cliente',
  },
  {
    name: 'cpfCnpjCliente',
    title: 'CPF/CNPJ',
  },
  {
    name: 'data',
    title: 'Data',
  },
  {
    name: 'valor',
    title: 'Valor',
  },
  {
    name: 'status',
    title: 'Fila Atual',
  },
];

const FIELDS_EDITAR_USUARIO = [
  {
    name: 'Nome',
    type: 'text',
    placeholder: 'Nome / Razão Social',
    label: 'Nome / Razão Social',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'email',
    type: 'text',
    placeholder: 'Email',
    label: 'Email',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'CPF',
    type: 'input-cpfcnpj',
    placeholder: 'CPF ou CNPJ do Cliente',
    label: 'CPF ou CNPJ do Cliente',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'Telefone',
    type: 'text',
    placeholder: 'Telefone',
    label: 'Telefone',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'perfil',
    type: 'select-multi',
    placeholder: 'Perfil',
    label: 'Perfil',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'Userid',
    type: 'text',
    placeholder: 'Funcional / CNPJ (Login de acesso)',
    label: 'Funcional / CNPJ (Login de acesso)',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'Status',
    type: 'select',
    placeholder: 'Selecione um Status',
    label: 'Status do usuário',
    options: [
      {
        text: 'Ativo',
        value: 0,
      },
      {
        text: 'Desativado',
        value: 255,
      },
      {
        text: 'Bloqueado',
        value: 254,
      },
    ],
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
];

const COLUMNS_ANALISE_EXCLUSAO = [
  {
    name: 'Farol',
    title: 'Farol',
    type: 'signal',
    rules: [
      { value: 'Alerta_Verde_16x16.png', color: '#c8e0d5', alt: 'Farol' },
      { value: 'Alerta_Amarelo_16x16.png', color: '#e0ce89', alt: 'Farol' },
      { value: 'Alerta_Vermelho_16x16.png', color: '#ebaa9c', alt: 'Farol' },
    ],
    width: '80px',
  },
  {
    key: true,
    name: 'Proposta',
    title: 'Número da Proposta',
  },
  { name: 'CpfCnpjCliente', title: 'CPF/CNPJ do Cliente' },
  { name: 'NomeCliente', title: 'Nome Cliente' },
  { name: 'Carteira', title: 'Carteira' },
  { name: 'Filial', title: 'Filial' },
  {
    name: 'DataSolicitacao',
    title: 'Data e Hora do Envio',
    dataFormat: (cell) => dateHourToBr(cell),
  },
  { name: 'Status', title: 'Status da Proposta' },
  { name: 'Motivo', title: 'Motivo' },
];

const FIELDS_CONSULTA_LOJAS = [
  {
    name: 'CPFCNPJ',
    type: 'input-cpfcnpj',
    placeholder: 'CNPJ da Loja',
    label: 'CNPJ da Loja',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'Nome',
    type: 'text',
    placeholder: 'Nome da Loja',
    label: 'Nome da Loja',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    type: 'dateRange',
    name: 'dataPreCadastro',
    label: 'Data Pré Cadastro',
    required: true,
    fields: [
      {
        name: 'DataInicial',
        type: 'date',
        placeholder: '',
        label: 'Pré-Cadastro - Inicial',
        sizeXs: 12,
        sizeSm: 6,
        sizeMd: 4,
        sizeLg: 3,
      },
      {
        name: 'DataFinal',
        type: 'date',
        placeholder: '',
        label: 'Pré-Cadastro - Final',
        sizeXs: 12,
        sizeSm: 6,
        sizeMd: 4,
        sizeLg: 3,
      },
    ],
  },
];

const COLUMNS_CONSULTA_LOJAS = [
  {
    name: 'CPFCNPJ',
    type: 'input-cpfcnpj',
    title: 'CNPJ',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'Nome',
    title: 'Razão Social',
  },
  {
    name: 'DataInclusao',
    title: 'Data - Pré-Cadastro',
    dataFormat: (cell) => dateHourToBr(cell),
  },
  {
    name: 'Produto',
    title: 'Produto',
  },
  {
    name: 'Status',
    title: 'Status',
  },
  {
    name: 'dataUltimaAcao',
    title: 'Data - Última Ação',
    dataFormat: (cell) => dateHourToBr(cell),
  },
];

const FILTRO_ANALISE_RISCO = [
  {
    name: 'proposta',
    type: 'number',
    placeholder: 'Número da Proposta',
    label: 'Número da Proposta',
    maxLength: 10,
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'cpfCnpjCliente',
    type: 'input-cpfcnpj',
    placeholder: 'CPF ou CNPJ do Cliente',
    label: 'CPF ou CNPJ do Cliente',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'CpfCnpjLoja',
    type: 'input-cpfcnpj',
    placeholder: 'CNPJ da Loja',
    label: 'CNPJ da Loja',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'CodGEFIN',
    type: 'text',
    placeholder: 'Código do GEFIN',
    label: 'Código do GEFIN',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'SUCOM',
    type: 'select-autocomplete',
    placeholder: 'SUCOM',
    label: 'SUCOM',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
    remote: {
      method: 'GET',
      service: 'consulta',
      path: 'consulta/sucoms',
    },
  },
  {
    name: 'Carteira',
    type: 'select-autocomplete',
    placeholder: 'Carteira',
    label: 'Carteira',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
    remote: {
      method: 'GET',
      service: 'consulta',
      path: 'consulta/carteiras',
    },
  },
  {
    name: 'Segmento',
    type: 'select',
    placeholder: 'Selecione um segmento',
    label: 'Segmento',
    options: [
      {
        text: 'Acima R$ 100.000,00',
        value: 'Acima R$ 100.000,00',
      },
      {
        text: 'Big Dealer',
        value: 'Big Dealer',
      },
      {
        text: 'Ford',
        value: 'Ford',
      },
      {
        text: 'Leves',
        value: 'Leves',
      },
      {
        text: 'Motos',
        value: 'Motos',
      },
      {
        text: 'Motos Harley',
        value: 'Motos Harley',
      },
      {
        text: 'Pre-Cadastro',
        value: 'Pre-Cadastro',
      },
      {
        text: 'Sinergia',
        value: 'Sinergia',
      },
      {
        text: 'Transportes',
        value: 'Transportes',
      },
    ],
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    type: 'dateRange',
    name: 'data',
    label: 'Data',
    required: true,
    fields: [
      {
        name: 'dataInicio',
        type: 'date',
        placeholder: '',
        label: 'Data Início',
        sizeXs: 12,
        sizeSm: 6,
        sizeMd: 4,
        sizeLg: 3,
      },
      {
        name: 'dataFim',
        type: 'date',
        placeholder: '',
        label: 'Data Fim',
        sizeXs: 12,
        sizeSm: 6,
        sizeMd: 4,
        sizeLg: 3,
      },
    ],
  },
  {
    type: 'timeRange',
    name: 'horaEnvio',
    label: 'Hora',
    required: true,
    fields: [
      {
        name: 'horaInicial',
        placeholder: 'Hora Inicial',
        label: 'Hora Inicial',
        sizeXs: 12,
        sizeSm: 6,
        sizeMd: 4,
        sizeLg: 3,
      },
      {
        name: 'horaFinal',
        placeholder: 'Hora Final',
        label: 'Hora Final',
        sizeXs: 12,
        sizeSm: 6,
        sizeMd: 4,
        sizeLg: 3,
      },
    ],
  },
  {
    name: 'status',
    type: 'select',
    placeholder: 'Selecione um status',
    label: 'Status',
    options: [
      {
        text: 'Análise de Risco',
        value: 'Análise de Risco',
      },
      {
        text: 'Análise PLD Ponte',
        value: 'Análise PLD Ponte',
      },
    ],
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
];

const COLUMNS_ANALISE_RISCO = [
  {
    key: true,
    name: 'Proposta',
    title: 'Número da Proposta',
  },
  {
    name: 'CpfCnpjCliente',
    title: 'CPF/CNPJ do Cliente',
    dataFormat: (cell) => maskCPFandCNPJ(cell),
  },
  { name: 'NomeCliente', title: 'Nome Cliente' },
  { name: 'Carteira', title: 'Carteira' },
  { name: 'Filial', title: 'Filial' },
  { name: 'DataEnvio', title: 'Data e Hora do Envio', dataFormat: (cell) => dateHourToBr(cell) },
  { name: 'Status', title: 'Status da Proposta' },
];

const FIELDS_PARAMETRIZACAO_DOCUMENTOS = [
  {
    name: 'produto',
    type: 'select',
    placeholder: 'Selecione um produto',
    label: 'Produto',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
    remote: {
      method: 'GET',
      service: 'mesaveic',
      path: 'preCadastroLojas/produtos',
    },
  },
  {
    name: 'item',
    type: 'select',
    placeholder: 'Selecione um item',
    label: 'Item',
    disabled: true,
    // As options serão preenchidas de acordo com o
    // valor do Produto na tela de consulta de param. doc.
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
];

const COLUMNS_PARAMETRIZACAO_DOCUMENTOS = [
  {
    name: 'Descricao',
    title: 'Documento',
  },
  {
    name: 'DataInclusao',
    title: 'Criação',
    dataFormat: (cell) => dateToBr(cell),
  },
];

const FILTRO_CADASTRO_FULL = [
  {
    name: 'funcional',
    type: 'select-autocomplete',
    placeholder: 'Funcional',
    label: 'Funcional',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
    remote: {
      method: 'GET',
      service: 'mesaveic',
      path: '/pagamentoFull/dadosGefin?buscaFuncionais=true',
    },
  },
  {
    name: 'cpfcnpj',
    type: 'input-cpfcnpj',
    placeholder: 'CNPJ Loja',
    label: 'CNPJ da Loja',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'codGefin',
    type: 'select-autocomplete',
    placeholder: 'Gefin',
    label: 'Código GEFIN',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
    remote: {
      method: 'GET',
      service: 'mesaveic',
      path: '/pagamentoFull/dadosGefin?buscaCodigos=true',
    },
  },
  {
    name: 'gefin',
    type: 'select-autocomplete',
    placeholder: 'Gefin',
    label: 'Gefin',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
    remote: {
      method: 'GET',
      service: 'mesaveic',
      path: '/pagamentoFull/dadosGefin?buscaNomes=true',
    },
  },
];

const COLUMNS_CADASTRO_FULL = [
  {
    name: 'usuario',
    title: 'Usuário',
    dataFormat: (cell) => maskCPFandCNPJ(cell),
  },
  {
    name: 'codigo',
    title: 'Cód.GEFIN/Loja',
  },
  {
    name: 'inicio',
    title: 'Data Início',
  },
  {
    name: 'fim',
    title: 'Data Fim',
  },
  {
    name: 'status',
    title: 'Ativar/Desativar Full',
    type: 'switch',
  },
];

const COLUMNS_CADASTRO_FULL_ATIVO = [
  {
    name: 'usuario',
    title: 'Usuário',
    dataFormat: (cell) => maskCPFandCNPJ(cell),
  },
  {
    name: 'codigo',
    title: 'Cód.GEFIN/Loja',
  },
  {
    name: 'inicio',
    title: 'Data Início',
  },
  {
    name: 'fim',
    title: 'Data Fim',
  },
  {
    name: 'status',
    title: 'Ativar/Desativar Full',
    type: 'switch',
  }
];

const FILTRO_CONSULTA_FULL = [
  {
    type: 'dateRange',
    name: 'dataFull',
    label: 'Período',
    required: true,
    fields: [
      {
        name: 'dataInicial',
        type: 'date',
        placeholder: '',
        label: 'Data Início',
        sizeXs: 12,
        sizeSm: 6,
        sizeMd: 4,
        sizeLg: 3,
      },
      {
        name: 'dataFinal',
        type: 'date',
        placeholder: '',
        label: 'Data Fim',
        sizeXs: 12,
        sizeSm: 6,
        sizeMd: 4,
        sizeLg: 3,
      },
    ],
  },
  {
    name: 'codGefin',
    type: 'select-autocomplete',
    placeholder: 'Cód GEFIN',
    label: 'Cód GEFIN',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
    remote: {
      method: 'GET',
      service: 'mesaveic',
      path: '/pagamentoFull/dadosGefin?buscaCodigos=true',
    },
  },
  {
    name: 'funcionalGefin',
    type: 'select-autocomplete',
    placeholder: 'Funcional GEFIN',
    label: 'Funcional GEFIN',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
    remote: {
      method: 'GET',
      service: 'mesaveic',
      path: '/pagamentoFull/dadosGefin?buscaFuncionais=true',
    },
  },
  {
    name: 'nomeGefin',
    type: 'select-autocomplete',
    placeholder: 'Nome GEFIN',
    label: 'Nome GEFIN',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
    remote: {
      method: 'GET',
      service: 'mesaveic',
      path: '/pagamentoFull/dadosGefin?buscaNomes=true',
    },
  },
  {
    name: 'codLoja',
    type: 'select-autocomplete',
    placeholder: 'Loja',
    label: 'Loja',
    required: true,
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
    remote: {
      method: 'GET',
      service: 'consulta',
      path: '/loja/autocomplete',
    },
  },
  {
    name: 'cnpjLoja',
    type: 'input-cpfcnpj',
    placeholder: 'CNPJ da Loja',
    label: 'CNPJ da Loja',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
];

const COLUMNS_CONSULTA_FULL = [
  {
    name: 'IdParametroDocumento',
    title: 'IdParametroDocumento',
    key: true,
    hidden: true,
  },
  {
    name: 'NomeOperador',
    title: 'Usuário',
  },
  {
    name: 'CodigoOperador',
    title: 'Cód. GEFIN/Loja',
  },
  {
    name: 'Userid',
    title: 'Funcional GEFIN/Loja',
  },
  {
    name: 'DataInicio',
    title: 'Data Inicial',
  },
  {
    name: 'DataFim',
    title: 'Data Final',
  },
];

const COLUMNS_CONSULTA_POS = [
  {
    "name": "contrato",
    "title": "Contrato",
    width: '160px',
  },
  {
    "name": "assinaturaDigital",
    "title": "Assinatura Digital",
    width: '160px',
  },
  {
    "name": "cpfCnpj",
    "title": "CPF ou CNPJ do Cliente",
    width: '190px',
  },
  {
    "name": "nomeDoCliente",
    "title": "Nome do Cliente",
    width: '160px',
  },
  {
    "name": "filial",
    "title": "Filial",
    width: '100px',
  },
  {
    "name": "carteira",
    "title": "Carteira",
    width: '100px',
  },
  {
    "name": "loja",
    "title": "Loja",
    width: '100px',
  },
  {
    "name": "gefin",
    "title": "GEFIN",
    width: '100px',
  },
  {
    "name": "statusPrincipal",
    "title": "Status Principal",
    width: '160px',
  },
];

const FILTRO_PARAMETRIZACAO_DOCUMENTOS_PP = [
  {
    name: 'IdTipoDocto',
    type: 'select-autocomplete',
    placeholder: 'Documento',
    label: 'Documento',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
    remote: {
      method: 'GET',
      service: 'consulta',
      path: '/consulta/tipoDocto',
    },
  },
  {
    type: 'dateRange',
    name: 'dataCriacao',
    label: 'Data Criação',
    required: true,
    fields: [
      {
        name: 'dataInicialCriacao',
        label: 'Data Criação - Inicial',
        sizeSm: 2,
        sizeMd: 3,
      },
      {
        name: 'dataFinalCriacao',
        label: 'Data Criação - Final',
        sizeSm: 2,
        sizeMd: 3,
      },
    ],
  },
];

const COLUMNS_PARAMETRIZACAO_DOCUMENTOS_PP = [
  {
    title: '',
    name: 'checked',
    type: 'checkbox',
  },
  {
    name: 'IdCriterio',
    hidden: true,
  },
  {
    name: 'Descricao',
    title: 'Documento',
    type: 'input',
  },
  {
    name: 'DataInclusao',
    title: 'Criação',
  },
];

const FIELDS_CONSULTA_LOJAS_PRE_ANALISE = [
  {
    name: 'CPFCNPJ',
    type: 'input-cpfcnpj',
    placeholder: 'CNPJ da Loja',
    label: 'CNPJ da Loja',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'Nome',
    type: 'text',
    placeholder: 'Nome da Loja',
    label: 'Nome da Loja',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    type: 'dateRange',
    name: 'dataCriacao',
    label: 'Data Criação',
    required: true,
    fields: [
      {
        name: 'DataInicial',
        label: 'Pré-Cadastro - Inicial',
        sizeSm: 2,
        sizeMd: 3,
      },
      {
        name: 'DataFinal',
        label: 'Pré-Cadastro - Final',
        sizeSm: 2,
        sizeMd: 3,
      },
    ],
  },
  {
    name: 'Produto',
    type: 'select',
    placeholder: 'Produto',
    label: 'Produto',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
    remote: {
      method: 'GET',
      service: 'mesaveic',
      path: 'preCadastroLojas/itens?IdProduto=FF7EFC0E-28F4-478F-8FF3-E2973499382A',
    },
  },
  {
    name: 'Fila',
    type: 'select',
    placeholder: 'Fila',
    label: 'Fila',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
    options: [
      {
        text: 'Pré-Análise',
        value: '55CEFE50-CFCD-480B-B3E3-56EDD37FD34E',
      },
      {
        text: 'Reanálise',
        value: 'BFCADD77-32A6-4862-B090-0FC8E2E4833F',
      },
    ],
  },
];

const COLUMNS_CONSULTA_LOJAS_PRE_ANALISE = [
  {
    name: 'CPFCNPJ',
    title: 'CNPJ',
    dataFormat: (cell) => maskCPFandCNPJ(cell),
  },
  {
    name: 'Nome',
    title: 'Razão Social',
  },
  {
    name: 'DataInclusao',
    title: 'Data - Pré-Cadastro',
    dataFormat: (cell) => dateToBr(cell),
  },
  {
    name: 'Produto',
    title: 'Produto',
  },
  {
    name: 'Status',
    title: 'Status',
  },
  {
    name: 'dataUltimaAcao',
    title: 'Data - Última Ação',
    dataFormat: (cell) => dateToBr(cell),
  },
];

const FIELDS_CONSULTA_LOJAS_RELATORIOS = [
  {
    name: 'relatorio',
    type: 'select',
    placeholder: 'Selecione um relatório',
    label: 'Relatório',
    required: true,
    options: [
      {
        text: 'SLA Pré-Análise',
        value: 'SLA_Pre_Analise',
      },
      {
        text: 'Inconsistência',
        value: 'Inconsistencia',
      },
      {
        text: 'Relatório Personalizado',
        value: 'Personalizado',
      },
    ],
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
];

const FIELDS_CONSULTA_LOJAS_RELATORIOS_INCONSISTENCIA = [
  {
    type: 'dateRange',
    name: 'dataCriacao',
    label: 'Data Criação',
    required: true,
    fields: [
      {
        name: 'DataInicial',
        label: 'Data - Inicial',
        sizeSm: 2,
        sizeMd: 3,
      },
      {
        name: 'DataFinal',
        label: 'Data - Final',
        sizeSm: 2,
        sizeMd: 3,
      },
    ],
  },
  {
    name: 'Produto',
    type: 'select',
    placeholder: 'Selecione um Produto',
    label: 'Produtos',
    options: [
      {
        text: 'Cadastro de Loja Nova – Correspondente Bancário',
        value: '1142d117-5db8-4e77-8ebc-f5879021eabb',
      },
      {
        text: 'Cadastro de Loja Nova – Acordo Comercial',
        value: 'ab92e672-3b91-48e5-8718-0191455711f0',
      },
      {
        text: 'Cadastro de Loja Nova - Substabelecido',
        value: 'e8487132-3a69-46ef-ae58-9ccce3ccf8fb',
      },
      {
        text: 'Contrato Customizado',
        value: '7694c65b-3ac3-4c90-b8d3-371925708f82',
      },
      {
        text: 'Alteração de dados cadastrais – Correspondentes',
        value: '6cf90beb-c532-45f7-ae91-060451ba5c51',
      },
      {
        text: 'Alteração de dados bancários – Correspondentes',
        value: '63069154-3feb-4db4-b34b-a5b8aa025e22',
      },
      {
        text: 'Aditivo para alteração de dados bancários – Substabelecido',
        value: '4ddab978-41a2-47c4-a954-80abdb9b899d',
      },
      {
        text: 'Alteração de Acordo Comercial para Correspondente Bancário',
        value: 'bd9c5a08-e163-4b9d-8369-9e93bc9f4ab2',
      },
    ],
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'Tipo',
    type: 'select',
    placeholder: 'Selecione um Tipo',
    label: 'Tipo',
    options: [
      {
        text: 'Sistêmico',
        value: 'Sistemico',
      },
      {
        text: 'Operação',
        value: 'Operacional',
      },
    ],
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
];

const FIELDS_LOJAS_RELATORIOS_PERSONALIZADO = [
  {
    name: 'filtroRelatorioPersonalizado',
    type: 'select-multi',
    placeholder: 'Filtros',
    label: 'Selecione os Filtros',
    required: true,
    options: FIELDS_CONSULTA_LOJAS_RELATORIOS_PERSONALIZADO,
    //onChange: (e, name) => setSelectedFilters(name),
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 6,
    sizeLg: 6,
  },
  {
    name: 'selecionarTodosPersonalizado',
    type: 'checkbox',
    label: 'Selecionar Todos',
    // onChange: (e) => {
    //   setChecked(e.target.checked)
    //   if (e.target.checked)
    //     setSelectedFilters(FIELDS_CONSULTA_LOJAS_RELATORIOS_PERSONALIZADO)
    //   else
    //     setSelectedFilters([])
    // },
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
];

const FIELDS_CONSULTA_LOJAS_RELATORIOS_SLA_PRE_ANALISE = [
  {
    type: 'dateRange',
    name: 'dataCriacao',
    label: 'Data Criação',
    required: true,
    fields: [
      {
        name: 'DataInicial',
        label: 'Data - Inicial',
        sizeSm: 2,
        sizeMd: 3,
      },
      {
        name: 'DataFinal',
        label: 'Data - Final',
        sizeSm: 2,
        sizeMd: 3,
      },
    ],
  },
];

const COLUMNS_CONSULTA_LOJAS_RELATORIOS = [
  {
    name: 'CPFCNPJ',
    title: 'CNPJ',
    dataFormat: (cell) => maskCPFandCNPJ(cell),
  },
  {
    name: 'Nome',
    title: 'Razão Social',
  },
  {
    name: 'Filial',
    title: 'Filial',
  },
  {
    name: 'Carteira',
    title: 'Segmento',
  },
  {
    name: 'Status',
    title: 'Status',
  },
];

const COLUMNS_CONSULTA_LOJAS_RELATORIOS_INCONSISTENCIA = [
  {
    name: 'Etapa',
    title: 'Etapa',
  },
  {
    name: 'CNPJ',
    title: 'CNPJ',
    dataFormat: (cell) => maskCPFandCNPJ(cell),
  },
  {
    name: 'NomeProduto',
    title: 'Produto',
  },
  {
    name: 'Tipo',
    title: 'Tipo',
  },
  {
    name: 'NomeUsuario',
    title: 'Usuário',
  },
  {
    name: 'Upload',
    title: 'Upload',
    dataFormat: (cell) => dateHourToBr(cell),
  },
  {
    name: 'Tipificacao',
    title: 'Tipificação',
    dataFormat: (cell) => dateHourToBr(cell),
  },
  {
    name: 'PreAnalise',
    title: 'Pré-Análise',
    dataFormat: (cell) => dateHourToBr(cell),
  },
  {
    name: 'Retipificacao',
    title: 'Retipificação',
    dataFormat: (cell) => dateHourToBr(cell),
  },
  {
    name: 'SLA',
    title: 'SLA',
  },
  {
    name: 'TotalDocumentos',
    title: 'Total Documentos',
  },
];

const COLUMNS_HISTORICO = [
  {
    name: 'tipo',
    title: 'Tipo de Relatório',
  },
  {
    name: 'data',
    title: 'Data',
    dataFormat: (cell) => dateToBr(cell),
  },
  {
    name: 'hora',
    title: 'Hora',
  },
  {
    name: 'usuario',
    title: 'Usuário',
  },
  {
    name: 'download',
    title: 'Download',
    type: 'custom',
  },
];

const COLUMNS_ANALISE_LOJAS = [
  {
    name: 'farol',
    title: 'Farol',
    type: 'signal',
    rules: [
      { value: 'Alerta_Verde_16x16.png', color: '#c8e0d5', alt: 'Farol' },
      { value: 'Alerta_Amarelo_16x16.png', color: '#e0ce89', alt: 'Farol' },
      { value: 'Alerta_Vermelho_16x16.png', color: '#ebaa9c', alt: 'Farol' },
    ],
    width: '80px',
  },
  {
    name: 'CPFCNPJ',
    type: 'input-cpfcnpj',
    title: 'CNPJ',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'Nome',
    title: 'Razão Social',
  },
  {
    name: 'Produto',
    title: 'Produto',
  },
  {
    name: 'Segmento',
    title: 'Segmento',
  },
  {
    name: 'dataUltimaAcao',
    title: 'Data - Ultima Ação',
    dataFormat: (cell) => dateHourToBr(cell),
  },
];

const COLUMNS_POS_PARAM_REGRA_SOLICITACAO = [
  {
    name: 'Estado',
    title: 'Estado',
  },
  {
    name: 'credenciada',
    title: 'Credenciada',
  },
  {
    name: 'qtdDocumentos',
    title: 'Qtd. Documentos',
  },
  {
    name: 'Status',
    title: 'Status',
    type: 'switch',
  },
];

const FIELDS_POS_PARAM_REGRA_SOLICITACAO = [
  {
    name: 'produto',
    required: true,
    type: 'select',
    placeholder: 'Selecione um Produto',
    label: 'Produto',
    options: [
      {
        text: 'Leasing',
        value: '2285a22c-c2f2-4637-8e5b-33da516ff57a',
      },
      {
        text: 'CDC',
        value: '33476bdc-d01f-45c9-abda-9138b365e434',
      },
    ],
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'estado',
    type: 'select',
    placeholder: 'Selecione um Estado',
    label: 'Estado',
    remote: {
      method: 'GET',
      service: 'consulta',
      path: 'cep/estados?formatado=true',
    },
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'credenciada',
    type: 'select',
    placeholder: 'Selecione uma Credenciada',
    label: 'Credenciada',
    remote: {
      method: 'GET',
      service: 'mesaveic',
      path: 'posPagamento/listar-credenciadas?formatado=true',
    },
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'diversosBens',
    type: 'select',
    placeholder: 'Selecione uma opção',
    label: 'Possui Diversos Bens?',
    options: [
      {
        text: 'Sim',
        value: true,
      },
      {
        text: 'Não',
        value: false,
      },
    ],
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
];

const FILTRO_CONSULTA_CHAMADOS = [
  {
    name: 'id',
    label: 'Número Chamado',
    type: 'number',
    placeholder: 'Número do chamado',
    sizeSm: 6,
    sizeMd: 3,
  },
  {
    name: 'modulo',
    label: 'Módulo',
    type: 'select',
    placeholder: 'Selecione',
    sizeSm: 6,
    sizeMd: 3,
    options: [
      {
        text: "Assinatura Digital",
        value: "Assinatura Digital"
      },
      {
        text: "Cadastramento Loja",
        value: "Cadastramento Loja"
      },
      {
        text: "Conformidade",
        value: "Conformidade"
      },
      {
        text: "Gestão de Acessos",
        value: "Gestão de Acessos"
      },
      {
        text: "Lojas",
        value: "Lojas"
      },
      {
        text: "Pré Pagamento",
        value: "Pré Pagamento"
      }
    ],
  },
  {
    name: 'tipoDeChamado',
    label: 'Tipo de chamado',
    type: 'select',
    placeholder: 'Selecione',
    sizeMd: 4,
    sizeLg: 3,
    options: [
      {
        value: "Falha",
        text: "Falha",
      },
      {
        value: "Lentidão",
        text: "Lentidão",
      },
      {
        value: "Indisponibilidade",
        text: "Indisponibilidade",
      },

      {
        value: "Melhoria",
        text: "Melhoria",
      },
    ],
  },
  {
    name: 'prioridade',
    label: 'Prioridade',
    type: 'select',
    placeholder: 'Selecione',
    sizeMd: 4,
    sizeLg: 3,
    options: [
      {
        value: "Altíssima",
        text: "Altíssima",
      },
      {
        value: "Alto",
        text: "Alta",
      },
      {
        value: "Médio",
        text: "Média",
      },
      {
        value: "Baixo",
        text: "Baixa",
      },
      {
        value: "Melhoria",
        text: "Melhoria",
      },
    ],
  },
  {
    name: 'status',
    label: 'Status',
    type: 'select',
    placeholder: 'Selecione',
    sizeMd: 3,
    options: [
      {
        value: 1,
        text: 'Não iniciado',
      },
      {
        value: [2,3,4],
        text: 'Análise e elaboração da correção',
      },
      {
        value: 5,
        text: 'Solucionado',
      },
      {
        value: 6,
        text: 'Encerrado',
      },
    ],
  },
  {
    name: 'name',
    label: 'Nome Usuário',
    type: 'select-autocomplete',
    placeholder: 'Nome do usuário',
    sizeSm: 6,
    sizeMd: 3,
    remote: {
      method: 'GET',
      service: 'servicedesk',
      path: 'options',
    },
  },
  {
    type: 'dateRange',
    name: 'dataCriacao',
    label: 'Data Criação',
    fields: [
      {
        name: 'createdDateStart',
        label: 'Data da Criação (Início)',
        sizeSm: 6,
        sizeLg: 3,
      },
      {
        name: 'createdDateFinish',
        label: 'Data da Criação (Fim)',
        sizeSm: 6,
        sizeLg: 3,
      },
    ],
  },
];
const COLUMNS_CONSULTA_CHAMADOS = [
  {
    name: 'farol',
    title: 'Farol',
    type: 'signal',
    rules: [
      { value: 'Alerta_Verde_16x16.png', color: '#4dbd74', alt: 'Dentro do prazo' },
      { value: 'Alerta_Amarelo_16x16.png', color: '#ffc107', alt: 'Próximo ao vencimento do prazo' },
      { value: 'Alerta_Vermelho_16x16.png', color: '#c80025', alt: 'Fora do prazo' },
      { value: 'Alerta_Cinza_16x16.png', color: '#c2c2c2', alt: 'Encerrado' },
    ],
    width: '80px',
  },
  {
    name: 'numero_chamado',
    title: 'Nº do Chamado',
  },
  {
    name: 'modulo',
    title: 'Módulo',
  },
  {
    name: 'funcionalidade',
    title: 'Funcionalidade',
  },
  {
    name: 'created_at',
    title: 'Data da Criação',
  },
  {
    name: 'date_solved',
    title: 'Data Conclusão',
  },
  {
    name: 'nome_usuario',
    title: 'Nome Usuário',
  },
  {
    name: 'prioridade',
    title: 'Criticidade',
  },
  {
    name: 'status',
    title: 'Status',
  },
];

const COLUMNS_CONSULTA_PLD = [
  {
    name: 'farol',
    rules: [
      {
        alt: 'Farol',
        color: '#c8e0d5',
        value: 'Alerta_Verde_16x16.png',
      },
      {
        alt: 'Farol',
        color: '#ebaa9c',
        value: 'Alerta_Vermelho_16x16.png'
      }
    ],
    title: 'Farol',
    type: 'signal',
    width: '80px'
  },
  {
    name: 'proposta',
    title: 'Número de Proposta',
    key: true,
    showMobile: true,
  },
  {
    name: 'cpfCnpj',
    title: 'CPF/CNPJ do Favorecido'
  },
  {
    name: 'nome',
    title: 'Nome/Razão Social do Favorecido'
  },
  {
    name: 'data',
    title: 'Data Vigência'
  },
  {
    name: 'status',
    title: 'Status Vigência',
  },
]

export {
  COLUMNS_CONSULTA_POS,
  COLUMNS_CONSULTA_PROPOSTA,
  LISTA_BANCOS,
  PROPOSTAS_FILA_LOADING_ACTIONS,
  FILTRO_PONTE,
  COLUMNS_CONSULTA_PONTE,
  COLUMNS_INSERIR_PENDENCIA,
  FILTRO_RELATORIO_CARGA_ONLINE,
  FILTRO_RELATORIO_PROCESSOS_PRINCIPAIS,
  COLUMNS_RELATORIO_CARGA_ONLINE,
  COLUMNS_RELATORIO_PROCESSOS_PRINCIPAIS,
  COLUMNS_EXCLUSAO_PROPOSTA,
  COLUMNS_LIBERACAO_PROPOSTA,
  FILTRO_CHECKLIST,
  COLUMNS_CHECKLIST,
  TABS_PROPOSTA,
  FILTRO_ATUALIZAR_EMAILS,
  COLUMNS_ATUALIZAR_EMAILS,
  FILTRO_CHECKLIST_AVALIACAO_COMFORMIDADE,
  COLUMNS_CHECKLIST_AVALIACAO_CONFORMIDADE,
  FILTRO_CONSULTA_HIERARQUIA,
  COLUMNS_CONSULTA_HIERARQUIA,
  COLUMNS_CONSULTA_HIERARQUIA_FILIAIS,
  FILTRO_CONSULTA_PERFIL,
  COLUMNS_CONSULTA_PERFIL,
  FILTRO_CONSULTA_USUARIOS,
  COLUMNS_CONSULTA_USUARIOS,
  FILTRO_REANALISE,
  COLUMNS_REANALISE,
  COLUMNS_REANALISE_EXCLUSAO,
  COLUMNS_FORMULARIOS_CONFORMIDADE,
  COLUMNS_CHECKLIST_RELATORIO_CONFORMIDADE,
  CICLO_RELATORIO_CONFORMIDADE,
  COLUMNS_ANALISE_EXCLUSAO,
  COLUMNS_ANALISE_LOJAS,
  COLUMNS_ANALISE_RISCO,
  COLUMNS_CADASTRO_FULL,
  COLUMNS_CADASTRO_FULL_ATIVO,
  COLUMNS_CONSULTA_CHAMADOS,
  COLUMNS_CONSULTA_FULL,
  COLUMNS_CONSULTA_LOJAS,
  COLUMNS_CONSULTA_LOJAS_PRE_ANALISE,
  COLUMNS_CONSULTA_LOJAS_RELATORIOS,
  COLUMNS_CONSULTA_LOJAS_RELATORIOS_INCONSISTENCIA,
  COLUMNS_HISTORICO,
  COLUMNS_HISTORICO_RELATORIO,
  COLUMNS_IMPRESSAO_DOCS,
  COLUMNS_MONITOR_ANALITICO,
  COLUMNS_MONITOR_COMERCIAL_PRE,
  COLUMNS_PARAMETRIZACAO_DOCUMENTOS,
  COLUMNS_PARAMETRIZACAO_DOCUMENTOS_PP,
  COLUMNS_POS_PARAM_REGRA_SOLICITACAO,
  COLUMNS_PRE_ANALISE_RISCO,
  COLUMNS_RELATORIO_USUARIOS_BLOQUEIO,
  COLUMNS_RELATORIO_USUARIOS_GESTAO,
  FIELDS_CADASTRO_USUARIO,
  FIELDS_CONSULTA_LOJAS,
  FIELDS_CONSULTA_LOJAS_PRE_ANALISE,
  FIELDS_CONSULTA_LOJAS_RELATORIOS,
  FIELDS_CONSULTA_LOJAS_RELATORIOS_INCONSISTENCIA,
  FIELDS_CONSULTA_LOJAS_RELATORIOS_SLA_PRE_ANALISE,
  FIELDS_EDITAR_USUARIO,
  FIELDS_PARAMETRIZACAO_DOCUMENTOS,
  FIELDS_POS_PARAM_REGRA_SOLICITACAO,
  FILTRO_ANALISE_RISCO,
  FILTRO_CADASTRO_FULL,
  FILTRO_CONSULTA_CHAMADOS,
  FILTRO_CONSULTA_FULL,
  FILTRO_MONITOR_COMERCIAL_PRE,
  FILTRO_PARAMETRIZACAO_DOCUMENTOS_PP,
  FILTRO_PRE_ANALISE_RISCO,
  STATUS_RELATORIO_CONFORMIDADE,
  COLUMNS_CONSULTA_PLD,
  FIELDS_LOJAS_RELATORIOS_PERSONALIZADO,
};
